<!-- TODO Use lists only and not hard code the serial numbers -->

<app-page-meta pageTitle="finzy - Terms of use"
               tags="finzy, peer to peer lending, peer to peer lending india, line of credit online, easy finance, need a loan, india credit finance, personal loans, easy loans, loan, loan india, current loan rates india, best loans india, best loan rates, cheapest loans india, high investment investment opportunities, investments, quick personal loans, low interest personal loans"
               description="finzy details the Terms and Conditions for use of this website. Please read these Terms and Conditions carefully.">
</app-page-meta>

<app-header>
</app-header>

<div class="container">
  <p class="terms-headertext">TERMS OF USE</p>

  <div class="row terms-maindiv">
    <div class="terms-mainrow">
      <p class="terms-head">Introduction</p>

      <p class="terms-main-content">This document is an electronic record in terms of the Information Technology Act,
        2000 and rules thereunder as applicable and the provisions pertaining to electronic records in various statutes
        as amended by the Information Technology Act, 2000. This electronic record is generated by a computer system and
        does not require any physical or digital signatures.</p>

      <p class="terms-main-content">This document is published in accordance with the provisions of Rule 3(1) of the
        Information Technology (Intermediaries Guidelines) Rules, 2011 that requires publishing the rules and
        regulations, privacy policy and terms of use for access or usage of this website.</p>

    </div>


    <div class="tabcontent">
      <mat-tab-group mat-align-tabs="start" [selectedIndex]="tabIndex">
        <mat-tab label="Borrower">
          <div class="borrowerdiv">
            <b>1. THE TERMS OF USE FOR BORROWERS</b>
            <br/>
            <br/>
            <div class="borrowerdivmain">
              1.1. The domain name www.finzy.com (<b>“Website”</b>) is owned and operated by Bridge Fintech Solutions
              Private Limited, a private limited company incorporated under the Companies Act, 2013 with its registered
              office at, L&T Crescent Bay, T-5, 2002, Jerbai Wadi Road, Parel, Mumbai 400 012, Maharashtra, India (hereinafter
              referred to as "<b>Bridge Fintech</b>”, which expression shall, unless it
              be repugnant to the context or meaning thereof, be deemed to include its successors, affiliates, partners
              and permitted assigns). The objective of the Website is to facilitate the lending and borrowing of
              capital, in accordance with the terms of the loan agreement to be executed between the lender and borrower
              (<b>“Services”</b>).
              <br/>
              <br/>
              1.2. Bridge Fintech does not guarantee any returns on any transactions consummated vis-à-vis the Website
              to any person, either directly or indirectly.
              <br/>
              <br/>
              1.3. For the purpose of these Terms of Use (<b>“Terms”</b>), wherever the context so requires, the term:
              <br/>
              <br/>
              <span class="borrowersubcontent">
                1.3.1. <b>“Borrower”</b> shall mean an individual resident in India, who is willing to borrow, using the Website and is registered as a ‘Borrower’ on the Website.
              </span>
              <br/>
              <br/>
              <span class="borrowersubcontent">
                1.3.2 <b>“Force Majeure Event”</b> shall mean any event that is beyond the reasonable control of Bridge Fintech and shall include, without limitation, sabotage, fire, flood, explosion, act of God, civil commotion, strikes, lockouts or industrial action of any kind, riots, insurrection, war, acts of government, computer hacking, civil disturbances, unauthorised access to computer data and storage device, computer crashes, virus attacks, breach of security and encryption, and any other similar events not within the control of Bridge Fintech and which Bridge Fintech is not able to overcome.
              </span>
              <br/>
              <br/>
              <span class="borrowersubcontent">
                1.3.3 <b>“Lender/Investor”</b> shall mean any Person permitted to lend in India, in accordance with applicable laws, who is willing to lend/invest on the Website and is registered as a ‘Lender’ on the Website.
              </span>
              <br/>
              <br/>
              <span class="borrowersubcontent">
                1.3.4 <b>“Borrower Escrow Account”</b> shall mean a non-interest bearing account maintained by Bridge Fintech with a scheduled commercial bank for the purposes of the Services.
              </span>
              <br/>
              <br/>
              <span class="borrowersubcontent">
                1.3.5 <b>“Person”</b> shall mean an individual, a corporation, a partnership, a joint venture, a trust, an unincorporated organization and any other legal entity.
              </span>
              <br/>
              <br/>

              <span class="borrowersubcontent">
                1.3.6 <b>“P2P Platform/s”</b> shall mean an intermediary providing the services of loan facilitation via online medium or otherwise, to persons desirous of lending on it or availing loan facilitation services provided by it.
              </span>
              <br/>
              <br/>
              <span class="borrowersubcontent">
                1.3.7 <b>“P2P Regulations”</b> shall mean Master Directions – Non-Banking Financial Company – Peer to Peer Lending Platform (Reserve Bank) Directions, 2017 dated October 4, 2017.
              </span>
              <br/>
              <br/>
              <span class="borrowersubcontent">
                1.3.8 <b>“Trustee”</b> a trustee appointed in accordance with the requirements under P2P Regulations to manage the Borrower Escrow Account.
              </span>
              <br/>
              <br/>
              1.4. Bridge Fintech reserves the right, at its sole discretion, to change, modify, add or remove portions
              of these Terms, at any time without any prior written notice to the Borrower. It is the Borrower’s sole
              responsibility to review these Terms periodically for updates or changes. The Borrower’s continued use of
              the Website or Services following the posting of changes shall be deemed to mean that the Borrower accepts
              and agrees to the revisions. As long as the Borrower complies with these Terms, Bridge Fintech grants the
              Borrower a personal, non-exclusive, non-transferable, limited privilege to enter and use the Website.
              <br/>
              <br/>
              1.5. Accessing, browsing or otherwise using the Website indicates the Borrower’s agreement to all the
              terms and conditions under these Terms. Borrower is advised to read these Terms carefully before
              proceeding. By impliedly or expressly accepting these Terms, the Borrower also accepts and agrees to be
              bound by all Bridge Fintech’s policies, including but not limited to its Privacy Policy as amended from
              time to time. The Borrower further agrees that the Borrower shall remain bound by Bridge Fintech’s
              policies, including but not limited to these Terms and the Privacy Policy for as long as any loans
              borrowed by the Borrower remain outstanding.
              <br/>
              <br/>
              1.6 &nbsp;Summary of the Terms of Use
              <br/>
              <br/>
              <div class="">
                <ol type=1>
                  <li><b>Membership Eligibility</b>
                    <br/>
                    This section lays down the eligibility criteria to use the Website.
                  </li>
                  <br/>

                  <li><b>Borrower’s Account and Registration Obligations</b>
                    <br/>
                    This section provides the manner and procedure of registration, using the Services of this Website.
                  </li>
                  <br/>


                  <li><b>Use of the Website</b>
                    <br/>
                    This section lays down the Borrower’s agreement to the terms governing the use of the Website.
                  </li>
                  <br/>


                  <li><b>Terms and Conditions of Service</b>
                    <br/>
                    This section lays down the terms and conditions governing the use of the Services provided by the
                    Website.
                  </li>
                  <br/>


                  <li><b>Fees</b>
                    <br/>
                    This section states lays down the terms and conditions governing the payment of fees by the Borrower
                    for the Services provided.
                  </li>
                  <br/>


                  <li><b>Confidentiality</b>
                    <br/>
                    This section states that Bridge Fintech shall not disclose confidential information to anyone except
                    as required by law.
                  </li>
                  <br/>


                  <li><b>Links to Third Parties’ Websites</b>
                    <br/>
                    This section declares that Bridge Fintech is not responsible and has no liability for the
                    functionality, actions, inactions, privacy settings, privacy policies, terms or content of any third
                    party websites.
                  </li>
                  <br/>


                  <li><b>Indemnification</b>
                    <br/>
                    This section states that the Borrower agrees to indemnify Bridge Fintech against any and all claims,
                    which may be incurred by Bridge Fintech, arising out of any breach to these Terms of Use or the
                    Privacy Policy.
                  </li>
                  <br/>


                  <li><b>Only a Platform</b>
                    <br/>
                    This section states that the Website is only a platform for facilitating the borrowing and lending
                    of capital.
                  </li>
                  <br/>


                  <li><b>Termination</b>
                    <br/>
                    This section states the conditions under which the Services to the Borrower under the Website may be
                    terminated.
                  </li>
                  <br/>

                  <li><b>Disclaimer of Warranties</b>
                    <br/>
                    This section explains that Bridge Fintech makes no representations or warranties of any kind as to
                    the operation of the Website, accuracy or completeness of the contents and information provided
                    herein.
                  </li>
                  <br/>

                  <li><b>Limitation of Liability</b>
                    <br/>
                    This section lays down the circumstances under which Bridge Fintech shall not liable to the
                    Borrower.
                  </li>
                  <br/>

                  <li><b>Governing Law and Resolution of Disputes</b>
                    <br/>
                    This section states that these Terms of Use shall be governed by the laws of India and that the
                    place of jurisdiction shall exclusively be in Bangalore, Karnataka, India.
                  </li>
                  <br/>


                  <li><b>Grievance Redressal Mechanism</b>
                    <br/>
                    This section states the details of the grievance redressal officer on occurrence of any grievances.
                  </li>
                  <br/>

                  <li><b>How to contact us</b>
                    <br/>
                    This section provides the details where the Borrower can reach out to Bridge Fintech.
                  </li>
                  <br/>
                  <li><b>Miscellaneous</b>
                    <br/>
                    This section provides certain clarifications for all parties concerned.
                  </li>

                </ol>
              </div>
              <br/>
              <br/>


              <div class="">
                <ol type=1>
                  <li><b>MEMBERSHIP ELIGIBILITY</b>
                    <br/>
                    Use of the Website is available only to Persons who can enter into legally binding contracts under
                    the Indian Contract Act, 1872. Persons who are "incompetent to contract" within the meaning of the
                    Indian Contract Act, 1872 including minors, un-discharged insolvents and persons of unsound mind are
                    not eligible to use the Website. Any person, if an individual under the age of 18 shall not register
                    as a Borrower on the Website and shall not transact on or use the Website. Bridge Fintech reserves
                    the right to terminate any Person’s membership and/or refuse to provide such Person with access to
                    the Website if it is brought to Bridge Fintech’s notice or if it is discovered that such Person is
                    not eligible to use the Website.
                  </li>
                  <br/>
                  <br/>


                  <li><b>BORROWER’S ACCOUNT AND REGISTRATION OBLIGATIONS</b>
                    <br/>
                    <ol style="list-style-type: none;">
                      <li>2.1. The Website allows very limited and restricted access to the Services for unregistered
                        users.
                      </li>
                      <br/>
                      <li>2.2. Creation of Borrower Account
                        <br/>
                        <ol style="list-style-type: none;">
                          <li>2.2.1 The Borrower may create an account (<b>“Borrower Account”</b>) based on information
                            to be filled in at the time of registering, which may include, mobile number and one time
                            password
                            or any valid email ID/user ID and password (collectively, <b>“Borrower Account
                              Information”</b>).
                          </li>
                          <br/>

                          <li>2.2.2. While registering with the Website to avail the Services, the Borrower shall not:
                            <ol type=i>
                              <li>create any Borrower Account for anyone other than the Borrower, unless such Person's
                                prior permission has been obtained;
                              </li>
                              <li>use a Borrower Account that is the name of another person with the intent to
                                impersonate that person;
                              </li>
                              <li>use a name for the Borrower Account that is a name that is otherwise offensive, vulgar
                                or obscene or otherwise unlawful; or
                              </li>
                              <li>create more than one Borrower Account on the Website.</li>

                            </ol>
                          </li>

                          <li>
                            2.2.3. Notwithstanding anything to the contrary contained hereinabove, while a third party,
                            with the consent of the Borrower, may create the Borrower Account on the Website, the actual
                            usage and operation of Borrower Account shall be consummated only by the Borrower himself.
                            Such third party may for this limited purpose use the Website, and for no other reason
                            whatsoever.
                          </li>
                        </ol>
                      </li>
                      <br/>


                      <li>2.3. Provision of Borrower’s Documentation
                        <br/>
                        <ol style="list-style-type: none;">
                          <li>2.3.1 In order for a Borrower to avail the Services from Bridge Fintech through the
                            Website and for the Borrower Account to go live, the Borrower is required to provide Bridge
                            Fintech with certain user information/documentation for verification in a form and manner
                            acceptable to Bridge Fintech, which shall include, <i>inter alia</i>, the following:
                            <ol type=i>
                              <li>Know Your Customer documents, such as proof of identity, address and recent
                                photograph;
                              </li>
                              <li>Aadhaar Number, name and address (for authentication with UIDAI);</li>
                              <li>Employment or income related documents</li>
                              <li>Permanent Account Number (PAN); and</li>
                              <li>Email ID and phone number verification.</li>
                            </ol>
                            In addition to the above, Bridge Fintech reserves the right to request the Borrower to
                            provide such other information/documentation as it may deem fit.

                          </li>
                          <br/>
                          <li>2.3.2. In case of co-applicant for a particular loan requirement of the Borrower, Bridge
                            Fintech may at its sole discretion require information/documentation for such co-applicant.
                          </li>
                        </ol>
                      </li>
                      <br/>


                      <li>2.4. Verification
                        <ol style="list-style-type: none;">
                          <li>2.4.1. The Borrower agrees that the use of Website, consequent upon the creation of the
                            Borrower Account, is subject to verification by Bridge Fintech of the documentation
                            indicated hereinabove. The Borrower acknowledges and agrees that Bridge Fintech may use and
                            disclose his information and documentation for the purpose of such verification, including
                            (without limitation) making inquiry through third parties, to ascertain the following:
                            <ol type=i>
                              <li>Financial strength of the Borrower;</li>
                              <li>Borrower’s credit worthiness; and</li>
                              <li>Loan amount eligibility.</li>
                            </ol>
                            The Borrower accepts that such verification may also be conducted for the purpose of
                            vetting, <i>inter alia</i>, the communication address, mobile phone data and employee or
                            business
                            details of the Borrower (as may be applicable). The Borrower further acknowledges that
                            Bridge Fintech reserves the right for such verification either on registration of the
                            Borrower Account or at any time thereafter. Such verification may be conducted through third
                            party service providers and the Borrower hereby authorises Bridge Fintech to share the
                            aforesaid information with such third party service providers for the purposes of
                            verification.
                          </li>
                          <br/>

                          <li>2.4.2 The Borrower hereby grants Bridge Fintech permission to conduct such verification,
                            in such form and manner as it may deem fit, and disclose his personal information and
                            documentation to third parties in the process. The Borrower also authorizes such third
                            parties to disclose to Bridge Fintech such information as may be requested by Bridge Fintech
                            for the purposes of the verification. Such information may be used by Bridge Fintech to
                            assign risk ratings to the Borrower and to determine recommended interest rate applicable to
                            the Borrower.
                          </li>
                          <br/>

                          <li>2.4.3. The Borrower agrees and acknowledges that any information relating to the Borrower,
                            including but not limited to any credit information report received from registered Credit
                            Information Companies (CIC), procured by Bridge Fintech, whether directly from the Borrower
                            or indirectly from any third party source, will be made available to the Lenders on the
                            Website, and the Borrower accordingly gives his consent for sharing of such information in
                            accordance with the terms hereof. For this purpose, the Borrower hereby provides Bridge
                            Fintech with a royalty-free, fully paid-up, worldwide, non-exclusive license to such use of
                            the Borrower’s information and such use by Bridge Fintech shall not constitute a violation
                            or infringement of the Borrower’s intellectual property.
                          </li>
                        </ol>
                      </li>
                      <br/>
                      <br/>


                      <li>2.5. Borrower Obligations
                        <ol style="list-style-type: none;">
                          <li>2.5.1. The Borrower will be responsible for maintaining the confidentiality of the
                            Borrower Account Information, and shall be fully responsible for all activities that occur
                            under the Borrower Account. The Borrower agrees to, (i) immediately notify Bridge Fintech of
                            any unauthorised use of the Borrower Account Information or any other breach of security;
                            and (ii) ensure that the Borrower exits from the Borrower Account at the end of each
                            session. Bridge Fintech cannot and will not be liable for any loss or damage arising from
                            the Borrower’s failure to comply with this Clause. The Borrower may be held liable for
                            losses incurred by Bridge Fintech or any user or visitor of the Website due to authorised or
                            unauthorised use of the Borrower Account, as a result of the Borrower’s failure in keeping
                            the Borrower Account Information confidential.
                          </li>
                          <br/>
                          <li>2.5.2. The Borrower shall ensure that the Borrower Account Information provided by the
                            Borrower in the Website’s registration form or any other information provided by the
                            Borrower for purpose of creation of the Borrower Account is complete, accurate and
                            up-to-date. Use of another Borrower’s account information for availing the Services of the
                            Website is expressly prohibited.
                          </li>
                          <br/>
                          <li>2.5.3 The Borrower shall ensure that the aggregate loans taken by him (whether for
                            transactions consummated through the Website or other P2P Platforms) does not exceed Rs.
                            10,00,000/- (Indian Rupees Ten Lakhs only) at any point of time. The Borrower shall be
                            required to provide declarations, from time to time, in a form and manner Bridge Fintech may
                            deem fit, confirming compliance with this Clause. The Borrower’s failure to comply with this
                            Clause shall entitle Bridge Fintech to indefinitely suspend or terminate or block access to
                            the Borrower Account on the Website and refuse to provide the Borrower with access to the
                            Website, or take such other action against the Borrower as it may deem fit.
                          </li>
                          <br/>
                          <li>2.5.4 The Borrower agrees that if the Borrower provides any information that is untrue,
                            inaccurate, not current or incomplete, (or becomes untrue, inaccurate, not current or
                            incomplete) or if Bridge Fintech has reasonable grounds to suspect that such information is
                            untrue, inaccurate, not current, incomplete, or not in accordance with the these Terms,
                            Bridge Fintech shall have the right to indefinitely suspend or terminate or block access to
                            the Borrower Account on the Website and refuse to provide the Borrower with access to the
                            Website.
                          </li>
                        </ol>
                      </li>

                    </ol>
                  </li>
                  <br/>
                  <br/>

                  <li><b>USE OF THE WEBSITE</b>
                    <br/>
                    <br/>
                    <ol style="list-style-type: none;">
                      <li>3.1. The Borrower agrees, undertakes and covenants that, during the use of the Website, the
                        Borrower shall not host, display, upload, modify, publish, transmit, update or share any
                        information that:
                        <br/>
                        <ol style="list-style-type: none;">
                          <li>3.1.1 Belongs to another person or entity and to which the Borrower does not have any
                            right.
                          </li>
                          <br/>
                          <li>3.1.2 Is grossly harmful, harassing, blasphemous, defamatory, obscene, pornographic,
                            paedophilic, libellous, invasive of another's privacy, hateful or racially or ethnically
                            objectionable, disparaging or encouraging money laundering or gambling, or otherwise
                            unlawful in any manner whatsoever.
                          </li>
                          <br/>
                          <li>3.1.3. Is misleading in any way.</li>
                          <br/>
                          <li>3.1.4. Involves the transmission of "junk mail", "chain letters", or unsolicited mass
                            mailing or "spamming".
                          </li>
                          <br/>
                          <li>3.1.5. Infringes upon or violates any third party's rights including, but not limited to,
                            intellectual property rights, rights of privacy (including without limitation unauthorized
                            disclosure of a person's name, email address, physical address or phone number) or rights of
                            publicity.
                          </li>
                          <br/>
                          <li>3.1.6. Tries to gain unauthorized access or exceeds the scope of authorized access to the
                            Website or to profiles, blogs, communities, account information, bulletins, or other areas
                            of the Website or solicits passwords or personally identifying information for commercial or
                            unlawful purposes from other Borrowers.
                          </li>
                          <br/>
                          <li>3.1.7. Interferes with another Borrower's use and enjoyment of the Website.</li>
                          <br/>
                          <li>3.1.8. Refers to any website or URL that, in Bridge Fintech’s sole discretion, contains
                            material that is inappropriate for the Website or any other website, contains content that
                            would be prohibited or violates the letter or spirit of these Terms.
                          </li>
                          <br/>
                          <li>3.1.9. Contains software viruses or any other computer codes, files or programs designed
                            to interrupt, destroy or limit the functionality of any computer resource; or contains any
                            trojan horses, worms or other computer programming routines that may damage, detrimentally
                            interfere with, diminish value of, surreptitiously intercept or expropriate any system, data
                            or personal information.
                          </li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                  <br/>
                  <br/>


                  <li><b>TERMS AND CONDITIONS OF SERVICE</b>
                    <ol style="list-style-type: none;">
                      <li>4.1. &nbsp;The Services by Bridge Fintech shall be provided for a term commencing from the
                        date the Borrower Account goes live.
                      </li>
                      <br/>

                      <li>4.2. Loan Listings
                        <ol style="list-style-type: none;">
                          <li>4.2.1. Once the Borrower Account is live, the Borrower shall be entitled to use the
                            Website to register and provide required information and documents in order to list his loan
                            requirements on the Website.
                          </li>
                          <br/>
                          <li>4.2.2. Prior to the listing of the loan request, the Borrower shall be required to provide
                            the following information:
                            <ol type=i>
                              <li>Purpose of borrowing;</li>
                              <li>Quantum of loan required; and</li>
                              <li>Any other information as may be requested by the Bridge Fintech.</li>
                            </ol>
                          </li>
                          <br/>
                          <li>4.2.3. Based on the information provided by the Borrower and Borrower’s information
                            procured by Bridge Fintech, whether directly or indirectly, Bridge Fintech will assess the
                            Borrower’s credit risk.
                          </li>
                          <br/>
                          <li>4.2.4. The Borrower accepts and agrees that Bridge Fintech has complete discretion to
                            assign credit score and credit rating and is further authorized to disclose such rating
                            assigned to a Borrower, in the manner indicated in these Terms. The Borrower understands
                            that all the Borrower’s information, as procured above, will be made public to all visitors
                            on the site and hereby gives his consent for the same.
                          </li>
                          <br/>
                          <li>4.2.5. The Borrower shall be required to accept the credit rating and rate of interest
                            offered within a specified time period, as may be communicated by Bridge Fintech. Borrower’s
                            failure to accept such credit rating and rate of interest within the specified time period
                            shall lead to withdrawal of the loan offer. Notwithstanding the foregoing, any renewal of
                            the loan offer shall be at the sole discretion of Bridge Fintech. The credit rating and rate
                            of interest, once assigned, for a particular loan request cannot be related to a loan
                            availed on any prior date by the Borrower.
                          </li>
                          <br/>
                          <li>4.2.6. The Borrower cannot contest or challenge the credit rating or seek explanation
                            regarding the methodology adopted to arrive at such credit rating. The credit scoring
                            methodology and credit rating methodology applicable to the Borrower may, at the sole
                            discretion of Bridge Fintech, be updated/amended from time to time. Bridge Fintech shall,
                            however, not be responsible for any loss whatsoever from such updates or amendments thereto.
                          </li>
                          <br/>
                          <li>4.2.7. Bridge Fintech shall disclose an overview of credit assessment/score methodology
                            and factors considered on the Website in accordance with the P2P Regulations.
                          </li>
                          <br/>
                          <li>4.2.8 It is hereby clarified that once the Borrower gives his acceptance, as required
                            under Clause 4.2.5 above, the Borrower’s loan would be listed. and listing cannot be amended
                            or withdrawn without the approval of Bridge Fintech and such acceptance shall further
                            constitute deemed acceptance for listing of the loan details on the Website, subject to
                            Bridge Fintech’s approval. Once approved, the Borrower's listing will be displayed and the
                            Borrower may receive offers for investments based on the loan listing.
                          </li>
                          <br/>
                          <li>4.2.9. The Borrower acknowledges that Bridge Fintech reserves the right to reject any
                            request for loan made by the Borrower without assigning any reason whatsoever. If a loan
                            request is rejected by Bridge Fintech, the Borrower shall be entitled to reapply for a loan
                            after a certain period of time, as decided by Bridge Fintech at its sole discretion.
                          </li>
                          <br/>
                          <li>4.2.10. Bridge Fintech shall place the information relating to loan listings on such
                            sections of the Website based on the credit rating assigned to the Borrower, as it may deem
                            fit and proper. Bridge Fintech also has the right to make visual modifications/edits on the
                            loan listings in order to fit its database and/or improve the user interface.
                          </li>
                          <br/>
                          <li>4.2.11. The loan listing of the Borrower shall be kept open for as long as Bridge Fintech
                            may deem fit in its sole discretion (<b>“Listing Period”</b>). The Borrower agrees that a
                            loan
                            listing may be frozen or removed from the Website, (i) if the loan request is fully funded
                            by the Lenders, before the expiry date of listing; or (ii) if the Lenders have agreed to
                            fund up to 70% of the requested loan amount (<b>“Minimum Threshold”</b>) on or prior to the
                            expiry
                            of the Listing Period, whichever is earlier. If, however, the Minimum Threshold is not
                            reached during the Listing Period, Bridge Fintech may, at its sole discretion, extend the
                            Listing Period by a further period, as decided by Bridge Fintech. It is hereby clarified
                            that Bridge Fintech shall not be liable to the Borrower for any non-fulfilment of the loan
                            request within the Listing Period or any further extended period (as the case may be).
                          </li>
                          <br/>
                          <li>4.2.12. The Borrower hereby agrees to receive information on his loan request from Bridge
                            Fintech, whether by e-mail or SMS notifications. The Borrower is required to intimate Bridge
                            Fintech immediately of any changes to the Borrower’ e-mail or mobile phone numbers. By
                            accepting these Terms, the Borrower further authorizes Bridge Fintech to get in touch with
                            the Borrower for communication and promotions, despite any Do Not Disturb requests made by
                            the Borrower.
                          </li>
                          <br/>
                          <li>4.2.13. For as long as the loan is subsisting and is repayable by the Borrower, or any
                            period as may be deemed fit by Bridge Fintech, the Borrower shall not be entitled to make
                            another loan request on the Website. For a fresh request for loan, the Borrower understands
                            that the process for verification and listing as provided in these Terms shall be commenced
                            again.
                          </li>
                          <br/>
                          <li>4.2.14. The Borrower shall be required to promptly intimate Bridge Fintech of any change
                            in his personal/employment/income and any other relevant information, whether prior to or
                            post the listing of his loan request on the Website. If, however, the Borrower does not
                            intimate Bridge Fintech of such a change in a timely manner, Bridge Fintech shall be
                            entitled to take all action available to it, including black-listing or blocking the
                            Borrower from using the Services on its Website.
                          </li>
                          <br/>
                          <li>4.2.15. Bridge Fintech shall not be held liable for any loss of data, technical or
                            otherwise, information, particulars supplied by the Borrower, due the reasons beyond its
                            control like corruption of data or delay or failure to perform as a result of a Force
                            Majeure Event.
                          </li>
                          <br/>
                          <li>4.2.16. Bridge Fintech shall have the sole discretion to determine the locations and pin
                            codes it may want to serve.
                          </li>
                        </ol>
                        <br/>
                        <br/>
                      </li>
                      <br/>
                      <br/>

                      <li>4.3. Formation of loan agreement
                        <ol style="list-style-type: none;">
                          <li>4.3.1. The Borrower agrees and understands that multiple Lenders may invest in the loan,
                            and that the Borrower shall not be entitled to reject a loan, for any reason whatsoever,
                            once the loan listing is displayed on the Website. By listing the Borrower’s requirement on
                            the Website, the Borrower agrees to accept all terms and conditions and any loan provided
                            based on the loan listing and shall not be entitled to either decide the number of Lenders
                            investing in the loan nor the right to select or reject any Lender. If, however, the
                            Borrower rejects a loan, Bridge Fintech shall be entitled to take all action available to
                            it, including black-listing or blocking the Borrower from using the Services on its Website.
                          </li>
                          <br/>
                          <li>4.3.2. Once the verification has been completed and the necessary documentation has been
                            received, Bridge Fintech shall act as the intermediary between the Borrower and Lender to
                            facilitate the execution of the loan agreement and related documentation.
                          </li>
                          <br/>
                          <li>4.3.3. Borrower agrees to sign and execute the loan agreements and to provide necessary
                            assistance to Bridge Fintech for, whether electronically or physically, executing the same.
                          </li>
                          <br/>
                          <li>4.3.4. Borrower further agrees to co-operate with Bridge Fintech or any third party
                            appointed by Bridge Fintech in (a) providing necessary documentation, (b) helping Bridge
                            Fintech or such third party to conduct physical verification of the Borrower, (c) executing
                            requisite documents, and (d) any other actions as may be required in relation to the loan
                            agreement.
                          </li>
                          <br/>
                        </ol>
                      </li>
                      <br/>
                      <br/>


                      <li>4.4 Disbursement of Loan
                        <br/>
                        Within a period of 5 (Five) working days of receipt of the executed copy of the loan agreement
                        and other relevant documents or scanned copy thereof, whichever is earlier or such further
                        period as may be required by Bridge Fintech, the loan shall be disbursed to the Borrower’s bank
                        account, details of which are provided by the Borrower. If there is any mistake in the account
                        details provided by the Borrower, the Borrower and not Bridge Fintech would be held responsible
                        for the same.
                      </li>
                      <br/>
                      <br/>


                      <li>4.5. Repayment & Prepayment of Loan
                        <br/>
                        <ol style="list-style-type: none;">
                          <li>4.5.1. The Borrower agrees and understands that the tenure of the loan shall be for such
                            tenure as indicated by Bridge Fintech on the Website.
                          </li>
                          <br/>
                          <li>4.5.2. The Borrower shall repay the loan, the interest thereon and all other outstanding
                            to the Lender, as per the given repayment schedule and details of the Equated Monthly
                            Instalments (EMI(s)) indicated on the Website. The amounts due and payable to the Lender(s)
                            shall be deducted automatically from the Borrower’s account for payment of the EMIs on a
                            monthly basis, and the Borrower hereby authorizes Bridge Fintech to make such automatic
                            deductions. All EMIs and all repayments shall be remitted to the Borrower Escrow Account or
                            if permitted by applicable law to another bank account as may be indicated by Bridge Fintech
                            to the Borrower. It is hereby clarified that for the payment of interest, the Website will
                            follow the following business day convention and interest will be calculated based on
                            actual/365 days’ basis. It is further clarified that the EMI indicated with the loan offer
                            may vary from the EMI indicated on the Website and actually payable to a Lender.

                          </li>
                          <br/>
                          <li>4.5.3. For disbursements made on or before the 15th of a month, the Borrower agrees that
                            the first EMI shall be paid by 5th of the following month, and for disbursements after the
                            15th of a month, the first EMI shall be paid by 5th of the month following the next month.
                            The Borrower will be given a grace period of minimum 5 (Five) days, post which, late fee and
                            penal interest shall be payable, as indicated in Clause 4.6 below.

                          </li>
                          <br/>
                          <li>4.5.4. Any policy on prepayment of loan amount or changes to the tenor of the loan shall
                            be at sole discretion of Bridge Fintech. Bridge Fintech, at its sole discretion, shall be
                            entitled to levy prepayment charges and/or penalties in lieu of such prepayment, which shall
                            be indicated to the Borrower on the Website.
                          </li>
                          <br/>
                          <li>4.5.5 The Lender shall not be entitled to ask the Borrower to prepay the loan amount, and
                            any prepayment shall be in accordance with the terms of the loan agreement and that
                            prepayment option shall be exercisable by the Borrower on any working day after the
                            disbursal of the loan amount, subject to the no prepayment dates specified on the Website.
                          </li>
                          <br/>
                          <li>4.5.6 Any part prepayment by Borrower shall be in multiple of Rs 1,000/- (Indian Rupees
                            One Thousand) with a minimum of Rs 5,000/- (Indian Rupees Five Thousand). Full prepayment by
                            Borrower can be of any outstanding amount.
                          </li>
                        </ol>
                      </li>
                      <br/>
                      <br/>


                      <li>4.6. Late Fees and Penal Interest
                        <br/>
                        <ol style="list-style-type: none;">
                          <li>4.6.1. The Borrower agrees that for any default or delay by the Borrower in payment for
                            dues towards EMIs to any Lender, a late fee and penal interest would be charged. Details of
                            such late fees and penal interest payable shall be made available on the Website as part of
                            the ‘Bridge Fintech Recovery Policy’ and the same shall be updated on a periodical basis.
                          </li>
                          <br/>
                          <li>4.6.2. The late fees and penal interest shall be payable by the Borrower from the date of
                            default till the date of actual payment of the EMI and such late fees and penal interest by
                            the Borrower. Bridge Fintech and/or the Lender shall also be entitled to exercise such other
                            remedies available to the Lender under applicable law.
                          </li>
                          <br/>
                          <li>4.6.3. In case of any payment received from Borrower towards any EMI, it is hereby
                            clarified that the funds so received shall be utilised in accordance with the terms of the
                            loan agreement.
                          </li>
                        </ol>
                      </li>
                      <br/>
                      <br/>

                      <li>4.7 Delay in repayment of loans
                        <br/>
                        <ol style="list-style-type: none;">
                          <li>4.7.1. The Borrower understands and accepts that any delay in repayment of the EMIs to any
                            Lender shall constitute a breach of these Terms.
                          </li>
                          <br/>
                          <li>4.7.2. It is hereby clarified that each Lender vis-à-vis these Terms has authorized Bridge
                            Fintech to follow up with the Borrower(s) for collection in case a Borrower delays in
                            payment of any instalment as per the agreed repayment schedule, even after the grace period
                            of at least 5 (Five) days is provided to the Borrower, in accordance with the terms of the
                            ‘Model Policy on Collection of Dues ’.
                          </li>
                          <br/>
                          <li>4.7.3. The Lender has further authorized Bridge Fintech to take all and any legal recourse
                            available to it for the recovery of the instalments due to the Lender, upon occurrence of an
                            event of default as identified in the loan agreement, in accordance with the terms of the
                            loan agreement read with the ‘Bridge Fintech Recovery Policy’.
                          </li>
                          <br/>
                          <li>4.7.4. Bridge Fintech also reserves the right to report any delinquent loan and/or delayed
                            payments to the relevant authorities such as the Credit Information Companies (CIC), and
                            other such databases, lists and authorities. Bridge Fintech may also report the case as an
                            NPA, i.e., a non-performing asset and/or indicate the Borrower as a ‘wilful defaulter’ on
                            the Website or other social forums and/or undertake any other action, as it may deem fit.
                            The Borrower hereby acknowledges exercise of such rights by Bridge Fintech and gives consent
                            to such rights being exercised.
                          </li>
                          <br/>
                          <li>4.7.5. It is hereby clarified that upon Bridge Fintech declaring a particular loan to be
                            an NPA, the Lender(s) are entitled to undertake any action against the delinquent Borrower
                            that they may deem fit.
                          </li>
                        </ol>
                      </li>
                      <br/>
                      <br/>

                      <li>4.8. Bridge Fintech offers no guarantee or warranty that:
                        <br/>
                        <ol style="list-style-type: none;">
                          <li>4.8.1. there would be a satisfactory response or any response at all, once the loan
                            listing is put on display and that loan offer and/or loan listing will result in a funded
                            loan;
                          </li>
                          <br/>
                          <li>4.8.2. the Borrower will be able to raise the entire loan amount, requested by the
                            Borrower; or
                          </li>
                          <br/>
                          <li>4.8.3. the Borrower will be entitled to loan at a specific rate of interest.</li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                  <br/>
                  <br/>


                  <li><b>FEES</b>
                    <ol style="list-style-type: none;">
                      <li>5.1. The Borrower hereby agrees that he shall be liable for all fees and charges associated
                        with the use of the Website and Services, which may include registration fee and a loan
                        processing fee, as may be applicable. Further details of the fees payable (including, but not
                        limited to the terms pertaining to such fees and the quantum thereof), has been set out in the
                        Section ‘Pricing & Fee’.
                      </li>
                      <br/>
                      <li>5.2. The Borrower hereby consents and agrees that Bridge Fintech may, at its discretion,
                        deduct the fees and charges indicated above, from the loan disbursement amount subject to
                        applicable laws or otherwise, or agree to accept the fees in any other manner from Borrower, at
                        its sole discretion. Provided however that, the Borrower shall at all times be liable towards
                        the Lenders for the entire loan amount disbursed to him pursuant to a loan listing, irrespective
                        of any fees paid by the Borrower to Bridge Fintech in accordance with the terms of this Clause.
                      </li>
                      <br/>
                      <li>5.3. It is hereby clarified that fees and charges, once paid, are non-refundable.</li>
                      <li>5.4. All payments made for the use of the Website by the Borrower shall be compulsorily in
                        Indian Rupees.
                      </li>
                      <br/>
                      <li>5.5. While availing any of the payment method/s available on the Website for availing the
                        Services, Bridge Fintech shall not be responsible for or assume any liability, whatsoever in
                        respect of any loss or damage arising directly or indirectly to the Borrower due to:
                        <br/>
                        <ol style="list-style-type: none;">
                          <li>5.5.1. Lack of authorization for any transaction(s), or</li>
                          <br/>
                          <li>5.5.2. Exceeding the preset limit mutually agreed by the Borrower and between bank/s, or
                          </li>
                          <br/>
                          <li>5.5.3. Any payment issues arising out of the transaction, or</li>
                          <br/>
                          <li>5.5.4. Rejection of transaction for any other reason(s) whatsoever.</li>
                        </ol>
                      </li>
                      <br/>
                      <li>5.6. Bridge Fintech holds the authority to temporarily/permanently suspend/terminate the
                        Borrower Account or refuse access in case of non-payment of fees due by the Borrower to Bridge
                        Fintech. Without limitation to the other rights and remedies available to Bridge Fintech, it
                        also reserves the right to take legal action for the same.
                      </li>
                    </ol>
                  </li>
                  <br/>
                  <br/>


                  <li><b>CONFIDENTIALITY</b>
                    <br/>
                    As elaborated under the Privacy Policy, Bridge Fintech will keep all confidential information
                    confidential, including the Borrower’s personal and business information, and shall not disclose it
                    to anyone except as required by law, and shall ensure that such confidential information is
                    protected with security measures and a degree of care that it would apply to its own confidential
                    information. Bridge Fintech acknowledges that its employees, directors, agents and contractors shall
                    use the confidential information only for the intended purpose for which it is provided. Bridge
                    Fintech shall use all reasonable endeavours to ensure that its employees, directors, agents and
                    contractors acknowledge and comply with the provisions of these Terms of confidentiality as if such
                    person was subject to these Terms of confidentiality.
                  </li>
                  <br/>
                  <br/>


                  <li><b>LINKS TO THIRD-PARTIES' WEBSITES</b>
                    <br/>
                    The Website may contain links and interactive functionality interacting with the websites of third
                    parties. Bridge Fintech is not responsible for and has no liability for the functionality, actions,
                    inactions, privacy settings, privacy policies, terms, or content of any such website. Before
                    enabling any sharing functions to communicate with any such website or otherwise visiting any such
                    website, Bridge Fintech strongly recommends that the Borrower reviews and understands the terms and
                    conditions, privacy policies, settings, and information-sharing functions of each such third-party
                    website.
                  </li>
                  <br/>
                  <br/>


                  <li><b>INDEMNIFICATION</b>
                    <br/>
                    The Borrower shall indemnify and hold harmless Bridge Fintech, its owner, licensee, affiliates,
                    subsidiaries, group companies (as applicable) and their respective officers, directors, agents, and
                    employees, from any claim or demand, or actions including reasonable attorneys' fees, made by any
                    third party or penalty imposed due to or arising out of the Borrower’s breach of these Terms,
                    Privacy Policy and other policies, or the Borrower’s violation of any law, rules or regulations or
                    the rights (including infringement of any intellectual property rights) of a third party.
                  </li>
                  <br/>
                  <br/>


                  <li><b>ONLY A PLATFORM</b>
                    <br/>
                    The Borrower acknowledges and agrees that the Website is strictly a technology platform and
                    infrastructure for connecting Borrowers and Lenders. Bridge Fintech shall not be liable for any
                    reason whatsoever for the Services and for any transactions consummated on the Website, and shall
                    bear no liability for the consequences to the Borrower, of the Borrower’s use of the Website. The
                    Borrower acknowledges and agrees that he shall be solely responsible for any and all transactions
                    facilitated on the Website through the Borrower Account.
                  </li>
                  <br/>
                  <br/>


                  <li><b>TERMINATION</b>
                    <br/>
                    <ol style="list-style-type: none;">
                      <li>10.1. Bridge Fintech, in its sole discretion, may modify, suspend, or terminate access to, all
                        or any portion of the Website at any time for any reason including termination for breach of any
                        of these Terms or the Privacy Policy.
                      </li>
                      <br/>
                      <li>10.2. The Borrower shall be entitled to terminate the Borrower’s access to the Website and the
                        Services thereof on the Borrower’s repayment of all outstanding principal, interest, fees and
                        charges in relation to Borrower’s loan listings on the Website.
                      </li>
                      <br/>
                      <li>10.3. None of the Borrower’s content shall remain accessible on the Website upon termination.
                        This information cannot be recovered by the Borrower, once the account is terminated.
                      </li>
                      <br/>
                      <li>10.4. The disclaimer of warranties, the limitation of liability, and the governing law
                        provisions shall survive any termination of these Terms.
                      </li>
                    </ol>
                  </li>
                  <br/>
                  <br/>


                  <li><b>DISCLAIMER OF WARRANTIES</b>
                    <br/>
                    THE WEBSITE AND ALL INFORMATION, CONTENT, MATERIALS AND SERVICES INCLUDED ON OR OTHERWISE MADE
                    AVAILABLE TO THE BORROWER THROUGH THE WEBSITE (COLLECTIVELY, THE "CONTENTS") ARE PROVIDED BY BRIDGE
                    FINTECH ON AN "AS IS," "AS AVAILABLE" BASIS, WITHOUT REPRESENTATIONS OR WARRANTIES OF ANY KIND.
                    BRIDGE FINTECH MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE
                    OPERATION OF THE WEBSITE, THE ACCURACY OR COMPLETENESS OF THE CONTENTS AND THE ACCURACY OF THE
                    INFORMATION OR RECEIPT OF LOANS. BRIDGE FINTECH SHALL HAVE NO RESPONSIBILITY FOR ANY DAMAGE TO THE
                    BORROWER’S COMPUTER SYSTEM OR LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD OF ANY CONTENT, MATERIALS,
                    DOCUMENT OR INFORMATION OR ANY OTHER LOSSES INCURRED BY THE BORROWER FOR FAILURE TO RECEIVE LOANS.
                    THE BORROWER EXPRESSLY AGREES THAT THE USE OF THE WEBSITE IS AT THE BORROWER’S SOLE RISK. BRIDGE
                    FINTECH WILL NOT BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF THE WEBSITE OR THE
                    SERVICES OR THE CONTENTS INCLUDING, WITHOUT LIMITATION, DIRECT, INDIRECT, PUNITIVE, AND
                    CONSEQUENTIAL DAMAGES, UNLESS OTHERWISE SPECIFIED IN WRITING. TO THE FULL EXTENT PERMITTED BY LAW,
                    BRIDGE FINTECH DISCLAIMS ANY AND ALL REPRESENTATIONS AND WARRANTIES WITH RESPECT TO THE WEBSITE AND
                    ITS CONTENTS, WHETHER EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, WARRANTIES OF TITLE,
                    MERCHANTABILITY, AND FITNESS FOR A PARTICULAR PURPOSE OR USE.
                  </li>
                  <br/>
                  <br/>


                  <li><b>LIMITATION OF LIABILITY</b>
                    <br/>
                    IN NO EVENT SHALL BRIDGE FINTECH, ITS DIRECTORS, EMPLOYEES OR AGENTS, BE LIABLE FOR ANY SPECIAL,
                    INCIDENTAL, INDIRECT OR CONSEQUENTIAL DAMAGES WHATSOEVER RESULTING FROM ANY (I) ERRORS, MISTAKES, OR
                    INACCURACIES OF CONTENT; (II) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER,
                    RESULTING FROM THE BORROWER’S ACCESS TO AND USE OF THE WEBSITE; (III) ANY UNAUTHORIZED ACCESS TO OR
                    USE OF THE SECURE SERVERS AND/OR ANY AND ALL PERSONAL AND/OR BUSINESS AND/OR FINANCIAL INFORMATION
                    STORED THEREIN; (IV) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE WEBSITE; (V) ANY
                    BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE, WHICH MAY BE TRANSMITTED TO OR THROUGH THE WEBSITE BY ANY
                    THIRD PARTY; AND/OR (VI) ANY ERRORS OR OMISSIONS IN ANY CONTENT OR FOR ANY LOSS OR DAMAGE OF ANY
                    KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED, EMAILED, TRANSMITTED, OR OTHERWISE MADE
                    AVAILABLE VIA THE WEBSITE, WHETHER BASED ON WARRANTY, CONTRACT, TORT, OR ANY OTHER LEGAL THEORY, AND
                    WHETHER OR NOT BRIDGE FINTECH IS ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. SUBJECT TO THE ABOVE
                    AND NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED IN THESE TERMS, THE MAXIMUM AGGREGATE
                    LIABILITY (WHETHER IN CONTRACT, TORT (INCLUDING NEGLIGENCE) OR EQUITY) OF BRIDGE FINTECH VIS-À-VIS
                    ANY BORROWER, REGARDLESS OF THE FORM OF CLAIM, SHALL BE LIMITED TO THE AGGREGATE OF FEES PAID BY THE
                    BORROWER TO BRIDGE FINTECH. THE FOREGOING LIMITATIONS OF LIABILITY WILL APPLY NOTWITHSTANDING THE
                    FAILURE OF ESSENTIAL PURPOSE OF ANY LIMITED REMEDY HEREIN.
                  </li>
                  <br/>
                  <br/>


                  <li><b>GOVERNING LAW AND DISPUTE RESOLUTION</b>
                    <br/>
                    These Terms shall be governed by and interpreted and construed in accordance with the laws of India.
                    The courts of Bangalore, Karnataka shall have exclusive jurisdiction over any disputes arising under
                    these Terms.
                  </li>
                  <br/>
                  <br/>


                  <li><b>GRIEVANCE REDRESSAL MECHANISM</b>
                    <br/>
                    In accordance with the Information Technology Act, 2000 and Rules made thereunder, the name and
                    contact details of the Grievance Officer are provided below:
                    <br/>
                    <p>
                      Name: John Stain Richard<br/>
                      Address: Bridge Fintech Solutions Private Limited,<br/>
                      118, 1st Floor, 80 Feet Road,<br/>
                      Koramangala 7th Block,<br/>
                      Bengaluru, Karnataka - 560095.<br/>
                      Cell: +91 98860 18625<br/>
                      E-mail: <a href="mailto:grievances@finzy.com">grievances@finzy.com</a>
                    </p>
                  </li>
                  <br/>

                  If the Borrower wishes to make a complaint regarding any violation of the provisions of these Terms,
                  the Borrower may send a written complaint to the Grievance Officer, who shall redress the complaint,
                  in accordance with ‘Bridge Fintech Grievance Redressal Policy’ read with the provisions of the
                  Information Technology Act, 2000 and Rules made thereunder.
                  <br/>
                  <br/>


                  <li><b>HOW TO CONTACT US</b>
                    <br/>
                    If the Borrower has any questions or concerns about these Terms, Bridge Fintech may be contacted at
                    <a href="mailto:support@finzy.com">support@finzy.com</a>.
                  </li>
                  <br/>

                  <li><b>MISCELLANEOUS</b>
                    <br/>
                    <ol style="list-style-type: none;">
                      <li>16.1 It is hereby clarified that the Reserve Bank of India does not accept any responsibility
                        for the correctness of any of the statements or representations made or opinions expressed by
                        Bridge Fintech, and does not provide any assurance for repayment of the loans lent on the
                        Website.
                      </li>
                      <br/>
                      <li>16.2 It is further clarified that if Bridge Fintech ceases to carry on its activities, i.e.,
                        acting as an intermediary providing the Services via the Website or is wound up, all existing
                        loan agreements facilitated on the Website will continue to be managed and administered in
                        accordance with the ‘Business Continuity Plan’.
                      </li>
                      <br/>
                      <li>16.3 As required by the Reserve Bank of India under the P2P Regulations, Bridge Fintech has
                        appointed Catalyst Trusteeship Limited as Trustee who shall have the ability to operate the
                        escrow accounts for both lending and repayment of loans, and all existing loans shall therefore
                        be managed and/or handled by the Trustee so appointed. The Borrower hereby ratifies the
                        appointment of such Trustee.
                      </li>
                    </ol>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </mat-tab>


        <mat-tab label="Investor">
          <div class="Investordiv">
            <b>1. THE TERMS OF USE FOR LENDERS</b>
            <br/>
            <br/>
            <div>
              1.1. The domain name www.finzy.com (<b>“Website”</b>) is owned and operated by Bridge Fintech Solutions
              Private Limited, a private limited company incorporated under the Companies Act, 2013 with its registered
              office at, L&T Crescent Bay, T-5, 2002, Jerbai Wadi Road, Parel, Mumbai 400 012, Maharashtra, India (hereinafter
              referred to as <b>"Bridge Fintech”</b>, which expression shall, unless it be
              repugnant to the context or meaning thereof, be deemed to include its successors, affiliates, partners and
              permitted assigns). The objective of the Website is to facilitate the lending and borrowing of capital, in
              accordance with the terms of the loan agreement to be executed between the lender and borrower (<b>“Services”</b>).
              <br/>
              <br/>
              1.2. Bridge Fintech does not guarantee any returns on any transactions consummated vis-à-vis the Website
              to any person, either directly or indirectly. The Lender shall be solely responsible for undertaking
              appropriate and effective due diligence and related analysis before investing pursuant to these Terms, and
              the Lender accepts and understands the risks associated with any transactions consummated vis-à-vis the
              Website.
              <br/>
              <br/>
              1.3. For the purpose of these Terms of Use (<b>“Terms”</b>), wherever the context so requires, the term:
              <br/>
              <br/>
              <ol style="list-style-type: none;">
                <li>1.3.1. <b>“Borrower”</b> shall mean an individual resident in India, who is willing to borrow, using
                  the Website and is registered as a ‘Borrower’ on the Website.

                </li>
                <br/>

                <li>1.3.2. <b>“Borrower Escrow Account”</b> shall mean a non-interest bearing account maintained by
                  Bridge
                  Fintech with a scheduled commercial bank for the purposes of the Services.
                </li>
                <br/>

                <li>1.3.3. <b>“Force Majeure Event”</b> shall mean any event that is beyond the reasonable control of
                  Bridge
                  Fintech and shall include, without limitation, sabotage, fire, flood, explosion, act of God, civil
                  commotion, strikes, lockouts or industrial action of any kind, riots, insurrection, war, acts of
                  government, computer hacking, civil disturbances, unauthorised access to computer data and storage
                  device, computer crashes, virus attacks, breach of security and encryption, and any other similar
                  events not within the control of Bridge Fintech and which Bridge Fintech is not able to overcome.

                </li>
                <br/>

                <li>1.3.4. <b>“Lender/Investor”</b> shall mean any Person permitted to lend in India, in accordance with
                  applicable laws, who is willing to lend/invest on the Website and is registered as a ‘Lender’ on the
                  Website.
                </li>
                <br/>

                <li>1.3.5. <b>“Lender Escrow Account”</b> shall mean a non-interest bearing account maintained by Bridge
                  Fintech with a scheduled commercial bank for the purposes of the Services.
                </li>

                <br/>

                <li>1.3.6. <b>“Person”</b> shall mean an individual, a corporation, a partnership, a joint venture, a
                  trust, an
                  unincorporated organization and any other legal entity.
                </li>

                <br/>

                <li>1.3.7 <b>“P2P Platform/s”</b> shall mean an intermediary providing the services of loan facilitation
                  via online medium or otherwise, to persons desirous of lending on it or availing loan facilitation
                  services provided by it.
                </li>

                <br/>

                <li>1.3.8 <b>“P2P Regulations”</b> shall mean Master Directions – Non-Banking Financial Company – Peer
                  to Peer Lending Platform (Reserve Bank) Directions, 2017 dated October 4, 2017.
                </li>

                <br/>

                <li>1.3.9 <b>“Trustee”</b> a trustee appointed in accordance with the requirements under P2P Regulations
                  to manage the Lender Escrow Account.
                </li>
              </ol>
              <br/>

              1.4. Bridge Fintech reserves the right, at its sole discretion, to change, modify, add or remove portions
              of these Terms, at any time without any prior written notice to the Lender. It is the Lender’s sole
              responsibility to review these Terms periodically for updates or changes. The Lender’s continued use of
              the Website or Services following the posting of changes shall be deemed to mean that the Lender accepts
              and agrees to the revisions. As long as the Lender complies with these Terms, Bridge Fintech grants the
              Lender a personal, non-exclusive, non-transferable, limited privilege to enter and use the Website.
              <br/>
              <br/>
              1.5. Accessing, browsing or otherwise using the Website indicates the Lender’s agreement to all the terms
              and conditions under these Terms. Lender is advised to read these Terms carefully before proceeding. By
              impliedly or expressly accepting these Terms, the Lender also accepts and agrees to be bound by all Bridge
              Fintech’s policies, including but not limited to its Privacy Policy as amended from time to time.
              <br/>
              <br/>
              1.6. <b>Summary of the Terms of Use</b>
              <br/>
              <br/>
              <div class="">
                <ol type=1>
                  <li><b>Membership Eligibility</b>
                    <br/>
                    This section lays down the eligibility criteria to use the Website.
                  </li>
                  <br/>

                  <li><b>Lender’s Account and Registration Obligations</b>
                    <br/>
                    This section provides the manner and procedure for registration, using the Services of this Website.
                  </li>
                  <br/>


                  <li><b>Use of the Website</b>
                    <br/>
                    This section lays down the Lender’s agreement to the terms governing the use of the Website.
                  </li>
                  <br/>


                  <li><b>Terms and Conditions of Service</b>
                    <br/>
                    This section lays down the terms and conditions governing the use of the Services provided by the
                    Website.
                  </li>
                  <br/>


                  <li><b>Fees</b>
                    <br/>
                    This section states lays down the terms and conditions governing the payment of fees by the Lender
                    for the Services provided.
                  </li>
                  <br/>


                  <li><b>Confidentiality</b>
                    <br/>
                    This section states that Bridge Fintech shall not disclose confidential information to anyone except
                    as required by law.
                  </li>
                  <br/>


                  <li><b>Links to Third Parties’ Websites</b>
                    <br/>
                    This section declares that Bridge Fintech is not responsible for and has no liability for the
                    functionality, actions, inactions, privacy settings, privacy policies, terms or content of any third
                    party websites.
                  </li>
                  <br/>


                  <li><b>Indemnification</b>
                    <br/>
                    This section states that the Lender agrees to indemnify Bridge Fintech against any and all claims,
                    which may be incurred by Bridge Fintech, arising out of any breach to these Terms of Use or the
                    Privacy Policy.
                  </li>
                  <br/>


                  <li><b>Only a Platform</b>
                    <br/>
                    This section states that the Website is only a platform for facilitating the borrowing and lending
                    of capital.
                  </li>
                  <br/>


                  <li><b>Termination</b>
                    <br/>
                    This section states the conditions under which the Services to the Lender under the Website may be
                    terminated.
                  </li>
                  <br/>

                  <li><b>Disclaimer of Warranties</b>
                    <br/>
                    This section explains that Bridge Fintech makes no representations or warranties of any kind as to
                    the operation of the Website, accuracy or completeness of the contents and information provided
                    herein.
                  </li>
                  <br/>

                  <li><b>Limitation of Liability</b>
                    <br/>
                    This section lays down the circumstances under which Bridge Fintech shall not liable to the Lender.
                  </li>
                  <br/>

                  <li><b>Governing Law and Resolution of Disputes</b>
                    <br/>
                    This section states that these Terms of Use shall be governed by the laws of India and that the
                    place of jurisdiction shall exclusively be in Bangalore, Karnataka, India.
                  </li>
                  <br/>


                  <li><b>Grievance Redressal Mechanism</b>
                    <br/>
                    This section states the details of the grievance redressal officer on occurrence of any grievances.
                  </li>
                  <br/>

                  <li><b>How to contact us</b>
                    <br/>
                    This section provides the details where the Lender can reach out to Bridge Fintech.
                  </li>

                  <br/>
                  <li><b>Miscellaneous</b>
                    <br/>
                    This section provides certain clarifications for all parties concerned.
                  </li>

                </ol>
              </div>

              <ol type=1>

                <li><b>MEMBERSHIP ELIGIBILITY</b>
                  <br/>
                  Use of the Website is available only to Persons who can enter into legally binding contracts under the
                  Indian Contract Act, 1872. Persons who are "incompetent to contract" within the meaning of the Indian
                  Contract Act, 1872 including minors, un-discharged insolvents and persons of unsound mind are not
                  eligible to use the Website. Any person, if an individual under the age of 18 shall not register as a
                  Lender on the Website and shall not transact on or use the Website. Bridge Fintech reserves the right
                  to
                  terminate any Person’s membership and/or refuse to provide such Person with access to the Website if
                  it
                  is brought to Bridge Fintech’s notice or if it is discovered that such Person is not eligible to use
                  the
                  Website.
                </li>
                <br/>
                <br/>

                <li><b>LENDER’S ACCOUNT AND REGISTRATION OBLIGATIONS</b>
                  <br/>
                  <ol style="list-style-type: none;">
                    <li>2.1. The Website allows very limited and restricted access to the Services for unregistered
                      users.
                    </li>
                    <br/>

                    <li>2.2. Creation of Lender Account
                      <br/>
                      <ol style="list-style-type: none;">
                        <li>2.2.1. The Lender may create an account (<b>“Lender Account”</b>) based on information to be
                          filled
                          in at the time of registering, which may include, mobile number and one time password or any
                          valid email ID/user ID and password (collectively, <b>“Lender Account Information”</b>).
                        </li>
                        <br/>
                        <li>2.2.2. While registering with the Website to avail the Services, the Lender shall not:
                          <br/>
                          <ol type=1>
                            <li>create any Lender Account for anyone other than the Lender, unless such Person's prior
                              permission has been obtained;
                            </li>
                            <br/>
                            <li>use a Lender Account that is the name of another person with the intent to impersonate
                              that person;
                            </li>
                            <br/>
                            <li>use a name for the Lender Account that is a name that is otherwise offensive, vulgar or
                              obscene or otherwise unlawful; or
                            </li>
                            <br/>
                            <li>create more than one Lender Account on the Website for any particular Lender.
                            </li>
                          </ol>
                        </li>
                        <br/>
                        <li>2.2.3. Notwithstanding anything to the contrary contained hereinabove, while a third party,
                          with the consent of the Lender, may create the Lender Account on the Website, the actual usage
                          and operation of Lender Account shall be consummated only by the Lender. Such third party may
                          for this limited purpose use the Website, and for no other reason whatsoever.
                        </li>
                      </ol>
                    </li>
                    <br/>


                    <li>2.3. Provision of Lender’s Documentation
                      <br/>
                      <ol style="list-style-type: none;">
                        <li>2.3.1. In order for a Lender to avail the Services from Bridge Fintech through the Website
                          and
                          for the Lender Account to go live, the Lender is required to provide Bridge Fintech with
                          certain
                          user information/documentation for verification in a form and manner acceptable to Bridge
                          Fintech, which shall include, <i>inter alia</i>, the following:
                        </li>
                        <br/>
                        <ol type=i>
                          <li>Know Your Customer documents, such as proof of identity, address and recent photograph;
                          </li>
                          <li>Permanent Account Number (PAN);</li>
                          <li>Aadhaar Number, name and address (for authentication with UIDAI); and</li>
                          <li>Email ID and phone number verification.</li>
                        </ol>

                        <br/><br/>
                        In addition to the above, Bridge Fintech reserves the right to request the Lender to provide
                        such
                        other information/documentation as it may deem fit.
                      </ol>
                    </li>
                    <br/>


                    <li>2.4. &nbsp;Verification
                      <br/>
                      <ol style="list-style-type: none;">
                        <li>2.4.1. The Lender agrees that the use of Website, consequent upon the creation of the Lender
                          Account, is subject to verification by Bridge Fintech of the documentation indicated
                          hereinabove.
                        </li>
                        <br/>
                        <li>2.4.2. The Lender hereby grants Bridge Fintech permission to conduct such verification, in
                          such form and manner as it may deem fit. Such verification may be conducted through third
                          party
                          service providers and the Lender hereby authorises Bridge Fintech to share the aforesaid
                          information with such third party service providers for the purposes of verification.
                        </li>
                      </ol>
                    </li>
                    <br/>


                    <li>2.5. Upon the Lender Account going live, the Lender shall be allowed to view the Borrowers’
                      listings on the Website, and can ascertain independently whether it/he would like to lend/invest
                      based on the risk ratings assigned to the Borrower. The Lender shall have the option to review the
                      listings and invest in loans manually or to ‘auto-invest’ on the Website, as further detailed upon
                      in Clause 4 below.
                    </li>
                    <br/>

                    <li>2.6 The information regarding a Borrower to be disclosed to the Lender vis-à-vis the Services
                      shall be in compliance with applicable laws, including the P2P Regulations.
                    </li>
                    <br/>

                    <li>2.7. Lender Obligations
                      <br/>
                      <ol style="list-style-type: none;">
                        <li>2.7.1. The Lender will be responsible for maintaining the confidentiality of the Lender
                          Account Information, and shall be fully responsible for all activities that occur under the
                          Lender Account. The Lender agrees to, (i) immediately notify Bridge Fintech of any
                          unauthorised
                          use of the Lender Account Information or any other breach of security; and (ii) ensure that
                          the
                          Lender exits from the Lender Account at the end of each session. Bridge Fintech cannot and
                          will
                          not be liable for any loss or damage arising from the Lender’s failure to comply with this
                          Clause. The Lender may be held liable for losses incurred by Bridge Fintech or any user or
                          visitor of the Website due to authorised or unauthorised use of the Lender Account, as a
                          result
                          of the Lender’s failure in keeping the Lender Account Information confidential.
                        </li>
                        <br/>
                        <li>2.7.2. The Lender shall ensure that the Lender Account Information provided by the Lender in
                          the Website’s registration form is complete, accurate and up-to-date. Use of another Lender’s
                          account information for availing the Services of the Website is expressly prohibited.
                        </li>
                        <br/>
                        <li>2.7.3. The Lender agrees that if the Lender provides any information that is untrue,
                          inaccurate, not current or incomplete, (or becomes untrue, inaccurate, not current or
                          incomplete) or if Bridge Fintech has reasonable grounds to suspect that such information is
                          untrue, inaccurate, not current, incomplete, or not in accordance with the these Terms, Bridge
                          Fintech shall have the right to indefinitely suspend or terminate or block access to the
                          Lender
                          Account on the Website and refuse to provide the Lender with access to the Website.
                        </li>
                        <br/>
                        <li>2.7.4. The Lender shall not be entitled to solicit loans from Borrowers, or establish any
                          direct or indirect contact with any Borrower, before or after investment.
                        </li>

                        <br/>
                        <li>2.7.5 The Lender shall ensure that its/his aggregate exposure to all borrowers (whether for
                          transactions consummated through the Website or other P2P Platforms) does not exceed Rs.
                          50,00,000/- (Indian Rupees Fifty Lakhs only) at any point of time. Further, the exposure of the
                          Lender towards the same Borrower shall not exceed Rs. 50, 000/- (Indian Rupees Fifty Thousand)
                          on the website or other P2P Platforms, at any given time. The Lender shall be required to
                          provide declarations, from time to time, in a form and manner Bridge Fintech may deem fit,
                          confirming compliance with this Clause. The Lender’s failure to comply with this Clause shall
                          entitle Bridge Fintech to indefinitely suspend or terminate or block access to the Lender
                          Account on the Website and refuse to provide the Lender with access to the Website, or take
                          such
                          other action against the Lender as it may deem fit.
                        </li>
                      </ol>
                    </li>

                  </ol>
                </li>
                <br/>
                <br/>


                <li><b>USE OF THE WEBSITE</b>
                  <br/>
                  <br/>
                  <ol style="list-style-type: none;">
                    <li>3.1. The Lender agrees, undertakes and covenants that, during the use of the Website, the Lender
                      shall not host, display, upload, modify, publish, transmit, update or share any information that:
                    </li>
                    <br/>
                    <ol style="list-style-type: none;">
                      <li>3.1.1. Belongs to another person or entity and to which the Lender does not have any right.
                      </li>
                      <br/>
                      <li>3.1.2. Is grossly harmful, harassing, blasphemous, defamatory, obscene, pornographic,
                        paedophilic, libellous, invasive of another's privacy, hateful or racially or ethnically
                        objectionable, disparaging or encouraging money laundering or gambling, or otherwise unlawful in
                        any manner whatsoever.
                      </li>
                      <br/>
                      <li>3.1.3. Is misleading in any way.</li>
                      <br/>
                      <li>3.1.4. Involves the transmission of "junk mail", "chain letters", or unsolicited mass mailing
                        or
                        "spamming".
                      </li>
                      <br/>
                      <li>3.1.5. Infringes upon or violates any third party's rights including, but not limited to,
                        intellectual property rights, rights of privacy (including without limitation unauthorized
                        disclosure of a person's name, email address, physical address or phone number) or rights of
                        publicity.
                      </li>
                      <br/>
                      <li>3.1.6. Tries to gain unauthorized access or exceeds the scope of authorized access to the
                        Website or to profiles, blogs, communities, account information, bulletins, or other areas of
                        the
                        Website or solicits passwords or personally identifying information for commercial or unlawful
                        purposes from other Lenders.
                      </li>
                      <br/>
                      <li>3.1.7. Interferes with another Lender's use and enjoyment of the Website.</li>
                      <br/>
                      <li>3.1.8. Refers to any website or URL that, in Bridge Fintech’s sole discretion, contains
                        material
                        that is inappropriate for the Website or any other website, contains content that would be
                        prohibited or violates the letter or spirit of these Terms.
                      </li>
                      <br/>
                      <li>3.1.9. Contains software viruses or any other computer codes, files or programs designed to
                        interrupt, destroy or limit the functionality of any computer resource; or contains any trojan
                        horses, worms or other computer programming routines that may damage, detrimentally interfere
                        with, diminish value of, surreptitiously intercept or expropriate any system, data or personal
                        information.
                      </li>
                    </ol>
                  </ol>
                </li>
                <br/>
                <br/>


                <li><b>TERMS AND CONDITIONS OF SERVICE</b>
                  <br/>
                  <br/>
                  <ol style="list-style-type: none;">
                    <li>4.1. The Services by Bridge Fintech shall be provided for a term commencing from the date the
                      Lender Account goes live.
                    </li>
                    <br/>
                    <li>4.2. Investments by the Lender</li>
                    <br/>
                    <ol style="list-style-type: none;">
                      <li>4.2.1. Upon the Lender Account going live, on the Website, the Lender will have an option to:
                      </li>
                      <br/>
                      <ol type=i>
                        <li>select multiple Borrower’s profiles to whom the Lender wishes to lend from various
                          Borrower’s
                          profiles listed on the Website (<b>“Selected Borrowers”</b>) (hereinafter, the <b>“Manual
                            Invest”</b>); or
                        </li>
                        <br/>
                        <li>exercise the ‘auto-invest’ option, available on the Website (<b>“Auto Invest”</b>).</li>
                      </ol>
                      <br/>
                      <li>4.2.2. In case of:</li>
                      <br/>
                      <ol type=i>
                        <li>Manual Invest, the Lender shall be required to select loans individually and commit
                          investment; or
                        </li>
                        <br/>
                        <li>Auto Invest, the Lender shall be required to choose auto invest on the Website and
                          investments
                          can happen any time after the commitment is made by the Lender, or
                        </li>
                        <br/>

                        <li>
                          Reinvest, the Lender shall be required to register for reinvestment option and investments can
                          happen any time after such registration by the Lender.
                        </li>
                        <br/>
                      </ol>

                      such amounts under either option, shall hereinafter be referred to as the <b>“Committed Investment
                      Amount”</b>.
                      <br/>


                      <li>4.2.3. The Lender shall remit the Committed Investment Amount, either before or at the time of
                        making an investment, to the Lender Escrow Account. The Lender shall not be entitled to change,
                        cancel or withdraw the Committed Investment Amount in any loan or withdraw the Committed
                        Investment Amount, unless otherwise approved by Bridge Fintech. Notwithstanding anything to the
                        contrary contained in these Terms, if the Lender has deposited any amount over and above the
                        Committed Investment Amount, the Lender shall be entitled to withdraw or otherwise deal with the
                        excess amount, as it/he may deem fit.
                      </li>
                      <br/>

                      <li>4.2.4. The Lender hereby represents and warrants to Bridge Fintech that the funds disbursed by
                        the Lender shall at all times be from legitimate sources and there is no international flow of
                        funds.
                      </li>
                      <br/>

                      <li>4.2.5. All investments made by the Lender vis-à-vis these Terms, and subject to other
                        conditions
                        as stipulated by Bridge Fintech from time to time, shall be:
                      </li>
                      <br/>
                      <ol type=i>
                        <li>above minimum investment amount indicated by Bridge Fintech, and shall further be in
                          multiples
                          of at least Rs. 1,000 (Indian Rupees One Thousand only) and above minimum loan amount in any
                          one
                          loan; and
                        </li>
                        <br/>
                        <li>split across multiple loans.</li>
                      </ol>
                      <br/>

                      <li>4.2.6. It is hereby clarified that no investment made by a Lender pursuant to these Terms
                        shall
                        be permitted in a loan already invested in by such Lender.
                      </li>
                      <br/>

                      <li>4.2.7. The Lender understands and accepts that the funds transferred to Lender Escrow Account,
                        being a non-interest bearing account, will not constitute a deposit with Bridge Fintech.
                      </li>
                    </ol>

                    <li>4.3. Manual Invest</li>
                    <br/>
                    <ol style="list-style-type: none;">
                      <li>4.3.1. The Lender agrees and acknowledges that it/he can invest in a single loan for a
                        Selected
                        Borrower only once.
                      </li>
                      <br/>
                      <li>4.3.2. The Lender further agrees and acknowledges that Bridge Fintech may, at its sole
                        discretion, specify percentages for maximum permissible exposure in any loan by a Lender.
                        However,
                        this limit may vary in case the loan is closed on reaching the Minimum Threshold amount of a
                        Selected Borrower or any other cases identified by Bridge Fintech.
                      </li>
                    </ol>
                    <br/>

                    <li>4.4. Auto Invest</li>
                    <br/>
                    <ol style="list-style-type: none;">
                      <li>4.4.1. Under the ‘auto invest’ option, the Lender hereby authorizes Bridge Fintech to
                        shortlist
                        and communicate the loans available for investment of the Committed Investment Amount, in the
                        following manner:
                      </li>
                      <br/>
                      <ol style="list-style-type: none;">
                        <li>4.4.1.1. Loans shortlisted by Bridge Fintech are displayed on the screen for the Lender to
                          review and give confirmation for investment, or
                        </li>
                        <br/>
                        <li>4.4.1.2. In the event, there is not enough loans available to shortlist or if a loan could
                          not
                          be disbursed for any reason or the Lender has chosen to reinvest any funds received on
                          prepayment, monthly EMI receipt, loan recovery, etc., the process mentioned below in 4.4.3. to
                          be followed for confirmation by Lender.
                        </li>
                        <br/>
                        <li>4.4.1.3. The Lender accepts that under this option, the Lender’s Committed Investment Amount
                          may be split across multiple loans and for such quantum, as may be determined by Bridge
                          Fintech,
                          at its sole discretion.
                        </li>
                      </ol>
                      <li>4.4.2. Bridge Fintech would be allowed to invest the Committed Investment Amount into another
                        loan, if originally identified loan could not be disbursed for any reason.
                      </li>
                      <li>4.4.3. The Lender hereby agrees and acknowledges that in the event Bridge Fintech determines
                        that there are not enough loans available to shortlist or if a loan could not be disbursed for
                        any
                        reason, then Bridge Fintech, based on an algorithm, will automatically suggest loans to the
                        Lender
                        once new loans are listed on the Website and determined to be suitable for the Lender from
                        Committed Investment Amount. The Lender shall be informed of such automatic determination by an
                        email sent to his registered mail id or with updates on the Lender dashboard on the Website or
                        any
                        other method decided by Bridge Fintech, providing details of such loans and the prospective
                        Borrowers (<b>“Queued Loan Proposal”</b>). The Lender shall have the option to either accept or
                        reject
                        such Queued Loan Proposal by either reverting to support@finzy.com with a rejection mail or by
                        rejection on the Lender dashboard on the Website or any other method decided by Bridge Fintech
                        within a period of 12 (Twelve) hours (<b>“Replacement Window”</b>) or refraining from reverting
                        as
                        above,
                        on the Queued Loan Proposal. If the Lender chooses to not revert with a rejection mail or by
                        rejection on the Lender dashboard on the Website or any other method decided by Bridge Fintech
                        within the Replacement Window, the loan will be disbursed to the prospective Borrower and the
                        Lender hereby provides its consent to Bridge Fintech and the Trustee to direct the disbursement
                        of
                        its investment amount as loan to the Borrower in accordance with the terms of any such Queued
                        Loan
                        Proposal. Replacement Window time will start from the time the email is sent from Bridge
                        Fintech’s
                        mail servers or availability of reject option on the Lender dashboard on the Website or any
                        other
                        method decided by Bridge Fintech. Late receipt, non-receipt, receipt in spam folder, late
                        action,
                        etc. will not have any bearing on the 12 (Twelve) hours timeline of Replacement Window.
                      </li>
                    </ol>
                    <br/>


                    <li>4.5. Reinvest</li>
                    <br/>
                    <ol style="list-style-type: none">
                      <li>4.5.1. Lender would have an option to ‘reinvest’ funds that become due to transfer to him on
                        following events:
                        <ol>
                          <li>Receipt of monthly EMIs</li>
                          <li>Part prepayment of any invested loan</li>
                          <li>Full prepayment of any invested loan</li>
                          <li>Any other scenario, where money is to be paid back to the Lender’s registered bank account
                          </li>
                        </ol>
                      </li>

                      <li>4.5.2. Lender would have an option to register or deregister for ‘reinvest’ option by logging
                        on
                        to the Website or by writing to support@finzy.com from registered mail id
                      </li>

                      <li>4.5.3. Registration or deregistration from ‘reinvest’ option may take upto 7 business days to
                        be
                        effected. Bridge Fintech can change this period at its sole discretion
                      </li>

                      <li>4.5.4. Under the ‘reinvest’ option, the Lender hereby authorizes Bridge Fintech to shortlist
                        and
                        communicate the loans available for investment of the Lender’s Committed Investment Amount by
                        following the process mentioned in 4.4.3. above<br/>
                        <ol style="list-style-type: none">
                          <li>
                            4.5.4.1 The Lender accepts that under this option, the Lender’s Committed Investment Amount
                            may be invested in a single loan or split across multiple loans and for such quantum, as may
                            be determined by Bridge Fintech, at its sole discretion.
                          </li>
                        </ol>
                      </li>

                      <li>4.5.5. Bridge Fintech would be allowed to invest the Committed Investment Amount into another
                        loan, if originally identified loan could not be disbursed for any reason.
                      </li>
                    </ol>

                    <li>4.6. Loan Funding</li>
                    <br/>
                    <ol style="list-style-type: none;">
                      <li>4.6.1. Upon the Minimum Threshold of a Borrower being met or the requested loan amount having
                        been funded by the Lender, alongwith other such Lenders, whichever is earlier, subject to the
                        expiry of the Replacement Window for individual Lender, the loan offer for that particular
                        Borrower shall be deemed to be closed.
                      </li>
                      <br/>
                      <li>4.6.2. It is hereby clarified that once the loan offer is closed, the Lender shall not be
                        entitled to withdraw from investing the agreed loan amount.
                      </li>
                      <br/>
                      <li>4.6.3. Upon the loan offer being closed and the necessary verification of the Borrower having
                        been completed, Bridge Fintech shall act as the intermediary between the Borrower and Lender to
                        facilitate the execution of the loan agreement and related documentation. The Lender hereby
                        undertakes to review individual loan details and review the standard loan agreement before
                        confirming investment on the Website or before the expiry of Replacement Window, as applicable.
                        Confirmation of a loan investment on the Website or expiry of the Replacement Window will be
                        recorded as electronic consent of the Lender to the loan agreement.
                      </li>
                      <br/>
                      <li>4.6.4. It shall be the sole responsibility of the Lender to review the loan agreement
                        alongwith
                        the ancillary documents, and to download a copy for its/his records and safe keeping.
                      </li>
                      <br/>
                      <li>4.6.5. The Lender understands that Bridge Fintech shall retain the original copy of the loan
                        agreement. The Lender further understands that it/he will be given access to a scanned version
                        of
                        the loan agreement on the Website.
                      </li>
                      <br/>
                      <li>4.6.6. The Lender understands that Bridge Fintech is entitled to disburse loans to the
                        Borrowers
                        on the basis of scanned documents, and accepts that Bridge Fintech shall not be held responsible
                        for any loss of original documents while in transit.
                      </li>
                      <br/>
                      <li>4.6.7. The Lender understands and accepts that the Lender’s Committed Investment Amount for
                        loans identified either under the Manual Invest or Auto Invest may not be disbursed for certain
                        reasons. In such a scenario, Bridge Fintech shall not be held liable for any failure of
                        disbursement.
                      </li>
                    </ol>
                    <br/>


                    <li>4.7. Disbursement of Loan
                      <br/>
                      <p>Within a period of 5 (Five) working days of receipt of the executed copy of the loan agreement
                        and other relevant documents or scanned copy thereof, whichever is earlier or such further
                        period
                        as may be required by Bridge Fintech, the loan shall be disbursed to the Borrower’s bank
                        account,
                        details of which are provided by the Borrower. The Lender hereby provides its consent to Bridge
                        Fintech and the Trustee to authorize the release of funds from the Lender Escrow Account to the
                        Borrower’s bank account in accordance with the terms hereof. If there is any mistake in the
                        account details provided by the Borrower, the Borrower and not Bridge Fintech would be held
                        responsible for the same.</p>
                      <p>In addition to the consent of the Lender to Bridge Fintech as provided for relevant services
                        and
                        authorisations under these terms, the Lender hereby expressly provides its consent to the
                        Trustee
                        to: (a) release the amounts in the Lender Escrow Account towards disbursement of loans to the
                        Borrowers; (b) release the amount received from repayment or prepayment of existing loans from
                        the
                        Borrower Escrow Account to the Lender’s registered bank account or to the Lender Escrow Account
                        for reinvestment, wherever applicable (c) release such amounts from the Lender Escrow Account to
                        Bridge Fintech as are required by Bridge Fintech towards payment of commission and other fees
                        and
                        charges to Bridge Fintech and recovery of the tax amounts by Bridge Fintech.
                      </p>
                    </li>


                    <li>4.8. Payment of invested amounts</li>
                    <br/>
                    <ol style="list-style-type: none;">
                      <li>4.8.1. The Lender hereby authorises Bridge Fintech to collect demand promissory notes,
                        cheques,
                        NACH mandates or any other means to ensure receipt of periodical payments from the Borrower. The
                        Lender further authorises Bridge Fintech to demand and collect such amounts from Borrower on a
                        periodical basis in accordance with the ‘Bridge Fintech Recovery Policy', and Bridge Fintech
                        shall
                        not be required to obtain any further consents from the Lender.
                      </li>
                      <br/>
                      <li>4.8.2. All payments (in relation to (EMI(s)) made by the Borrower(s) including any penalties
                        or
                        late fees, shall be deposited in the Borrower Escrow Account and if permitted by applicable
                        laws,
                        another bank account as may be indicated by Bridge Fintech to the Lender, in a manner Bridge
                        Fintech may deem fit and as indicated in the loan agreement.
                      </li>
                      <br/>
                      <li>4.8.3. The collected payments in the bank account indicated above, and details of such
                        remittances received shall be provided to the Lender within a period of 5 (Five) working days of
                        receipt of such payments. EMIs of all loans of a Lender may be consolidated into a single entry
                        or
                        may be credited as separate entries, as Bridge Fintech deems fit, and all details in relation
                        thereto will be updated suitably on the Website. All amounts received from any Borrower would be
                        distributed amongst Lenders strictly in proportion of the amount invested by each Lender in a
                        particular loan.
                      </li>
                      <br/>
                      <li>4.8.4. The Lender shall not be entitled to ask the Borrower to prepay the loan amount, and any
                        prepayment shall be in accordance with the terms of the loan agreement and that no prepayment
                        option shall be exercisable by the Borrower prior to the expiry of minimum number of EMI
                        repayments as set out in the prepayment policy indicated in the Borrower Terms. The Lenders
                        hereby
                        accept that Bridge Fintech shall not be required to intimate any of the Lenders of such
                        prepayment
                        instruction made by the Borrower, and authorize Bridge Fintech to take any actions as it may
                        deem
                        fit pursuant to a prepayment instruction received by it.
                      </li>
                      <br/>
                      <li>4.8.5. Bridge Fintech shall be entitled to reinvest the monthly collections received by it
                        from
                        the Borrower based on instruction of the Lenders. Provided however that, any amount below the
                        minimum investment amount in a loan may remain uninvested and would not accordingly earn any
                        interest in relation to the amount thereon.
                      </li>
                      <br/>
                      <li>4.8.6. Bridge Fintech might deduct tax at source for any interest income as required by Income
                        Tax rules or as directed by Income Tax authorities.
                      </li>
                    </ol>
                    <br/>


                    <li>4.9. Recovery of loans</li>
                    <br/>
                    <ol style="list-style-type: none;">
                      <li>4.9.1. The Lender hereby authorizes Bridge Fintech to follow up with the Borrower(s) for
                        collection in case a Borrower delays in payment of any instalment as per the agreed repayment
                        schedule, even after the grace period of at least 5 (Five) days is provided to the Borrower, in
                        accordance with the terms of the ‘Bridge Fintech Recovery Policy’.
                      </li>
                      <br/>
                      <li>4.9.2. The Lender further authorizes Bridge Fintech to take all and any legal recourse
                        available
                        to it for the recovery of the instalments due to the Lender, or upon occurrence of an event of
                        default as identified in the loan agreement, in accordance with the terms of the loan agreement
                        read with the ‘Bridge Fintech Recovery Policy’. By accepting these Terms (read with the ‘Bridge
                        Fintech Recovery Policy’) and the loan agreement, Bridge Fintech shall not be required to obtain
                        any further consent of the Lender to pursue such legal recourse.
                      </li>
                      <br/>
                      <li>4.9.3. The Lender agrees that the Lender shall not approach, coerce or pursue any
                        communication
                        with any Borrower for such recovery of instalments, or the outstanding loan amount.
                      </li>
                      <br/>
                      <li>4.9.4. In the event that Bridge Fintech is able to recover some amount of money due to the
                        Lender, the collection charges for the same shall be deducted before depositing the money into
                        the
                        Lender’s account. For the purpose of such recovery, Bridge Fintech may also liaise with
                        collection
                        agencies to collect all the dues, including the money spent in recovery, from the Borrower.
                        Bridge
                        Fintech shall not be held liable for actions and methods of such collection agencies or any
                        other
                        third party agents for recovery of loans.
                      </li>
                      <br/>
                      <li>4.9.5. Bridge Fintech hereby undertakes to recover all or part of outstanding amount on a best
                        efforts basis, the same is duly acknowledged by the Lender under these Terms. Bridge Fintech
                        may,
                        at its sole discretion, decide not to pursue recovery or stop the process of recovery, and
                        accordingly to write off a particular loan; such decision of Bridge Fintech shall be intimated
                        to
                        the all the Lenders for such loan. The Lender further agrees that any and all decision taken by
                        Bridge Fintech for recovery of a particular loan from a Borrower shall be binding on all the
                        Lenders that had invested in such loan.
                      </li>
                      <br/>
                      <li>4.9.6. The Lender agrees hereby that all costs and expenses incurred in recovery and pursuing
                        legal recourse for a particular loan shall have to be borne by the Lenders in proportion of
                        their
                        investment amount in relation thereto.
                      </li>
                      <br/>
                      <li>4.9.7. Bridge Fintech shall not be liable to the Lender(s) for any delay, failure or decision
                        of
                        not to purse recovery or legal recourse in relation to a particular loan.
                      </li>
                    </ol>
                    <br/>


                    <li>4.10. Bridge Fintech also reserves the right to report any delinquent loan and/or delayed
                      payments
                      to the relevant authorities such as the Credit Information Companies (CIC), and other such
                      databases, lists and authorities. Bridge Fintech may also report the case as an NPA, i.e., a
                      non-performing asset and/or indicate the Borrower as a ‘wilful defaulter’ on the Website or other
                      social forums and/or undertake any other action, as it may deem fit.
                    </li>
                    <br/>

                    <li>4.11. It is hereby clarified that upon Bridge Fintech declaring a particular loan to be an NPA,
                      the Lenders shall be entitled to undertake any action against the Borrower that they may deem fit.
                    </li>
                    <br/>

                    <li>4.12. The Lender hereby agrees to receive information on status of an investment in loans,
                      performance of loans, amount of EMI collection or prepayment, whether by e-mail or SMS
                      notifications. The Lender is required to intimate Bridge Fintech immediately of any changes to the
                      Lender’s e-mail or mobile phone numbers. By accepting these Terms, the Lender further authorizes
                      Bridge Fintech to get in touch with the Lender for communication and promotions, despite any Do
                      Not
                      Disturb requests made by the Lender.
                    </li>
                    <br/>

                    <li>4.13. Bridge Fintech shall not be held liable for any loss of data, technical or otherwise,
                      information, particulars supplied by the Lender, due the reasons beyond its control like
                      corruption
                      of data or delay or failure to perform as a result of a Force Majeure Event.
                    </li>
                    <br/>

                    <li>4.14. Subject to applicable laws and these Terms, the Lender shall be entitled to transfer
                      the loans taken from it/him to another registered Lender on the Website, provided Bridge Fintech’s
                      prior approval has been obtained for the same. The Lender accordingly acknowledges that all rights
                      related to such loans will also transfer to such registered Lender.
                    </li>
                    <br/>

                    <li>4.15. Bridge Fintech offers no guarantee or warranty that:</li>
                    <br/>
                    <ol style="list-style-type: none;">
                      <li>4.15.1. the Commitment Investment Amount would be partially/fully invested;</li>
                      <br/>
                      <li>4.15.2. the Lender will receive any minimum rate of return on any Committed Investment Amount,
                        or
                      </li>
                      <br/>
                      <li>4.15.3. Bridge Fintech will be able to fully or partially collect the amounts due to the
                        Lender
                        from the Borrower and the Lender accepts and understands that there exists a likelihood of loss
                        of
                        entire amounts invested by it/him in case of default by a borrower; or
                      </li>
                      <br/>
                      <li>4.15.4. the credit score and credit rating assigned by Bridge Fintech will ensure full or
                        partial repayments from the Borrower.
                      </li>
                    </ol>
                    <br/>


                    <li>4.16. The Lender accepts that Bridge Fintech is entitled to:</li>
                    <br/>
                    <ol style="list-style-type: none;">
                      <li>4.16.1. choose not to accept any new investment or further investments from any Lender, as it
                        may deem fit; or
                      </li>
                      <br/>
                      <li>4.16.2. take decisions in relation to introduction of new features or taking out any features
                        on
                        and from the Website, from time to time.
                      </li>
                    </ol>
                    <br/>
                    The Lender acknowledges that Bridge Fintech shall not be held liable to the Lender for any such
                    decision taken by it.
                    <br/>


                    <li>4.17. Bridge Fintech shall have the sole discretion to determine the locations and pin codes it
                      may want to serve.
                    </li>
                    <br/>

                    <li>4.18. The Lender acknowledges that returns that a Lender is entitled to shall be solely
                      dependent
                      on performance of invested loans.
                    </li>
                  </ol>
                </li>
                <br/>
                <br/>


                <li><b>FEES</b>
                  <ol style="list-style-type: none;">
                    <li>5.1. The Lender hereby agrees that it/he shall be liable for all fees and charges associated
                      with
                      the use of the Website and Services, which may include registration fee. Further details of the
                      fees
                      payable (including, but not limited to the terms pertaining to such fees and the quantum thereof),
                      has been set out in the Section ‘Pricing & Fee’.
                    </li>
                    <br/>
                    <li>5.2. Bridge Fintech may, at its discretion, deduct the fees and charges indicated above, from
                      the
                      repayment amount collected from Borrower subject to applicable laws or otherwise, and the Lender
                      consents to such deduction, or agree to accept the fees in any other manner from Lender.
                    </li>
                    <br/>
                    <li>5.3. It is hereby clarified that fees and charges, once paid, are non-refundable.
                    </li>
                    <br/>

                    <li>5.4. All payments made for the use of the Website by the Lender shall be compulsorily in Indian
                      Rupees.
                    </li>
                    <br/>
                    <li>5.5. While availing any of the payment method/s available on the Website for availing the
                      Services, Bridge Fintech shall not be responsible for or assume any liability, whatsoever in
                      respect
                      of any loss or damage arising directly or indirectly to the Lender due to:
                    </li>
                    <br/>
                    <ol style="list-style-type: none;">
                      <li>5.5.1. Lack of authorization for any transaction(s), or</li>
                      <br/>
                      <li>5.5.2. Exceeding the preset limit mutually agreed by the Lender and between bank/s, or</li>
                      <br/>
                      <li>5.5.3. Any payment issues arising out of the transaction, or</li>
                      <br/>
                      <li>5.5.4. Rejection of transaction for any other reason(s) whatsoever.</li>
                    </ol>
                    <br/>


                    <li>5.6. Bridge Fintech holds the authority to temporarily/permanently suspend/terminate the Lender
                      Account or refuse access in case of non-payment of fees due by the Lender to Bridge Fintech.
                      Without
                      limitation to the other rights and remedies available to Bridge Fintech, it also reserves the
                      right
                      to take legal action for the same. Upon such termination, to the extent that a loan agreement has
                      been signed with Borrower(s), the Lender shall not be entitled to refund of such loan amount.
                    </li>
                  </ol>
                </li>
                <br/>
                <br/>


                <li><b>CONFIDENTIALITY</b>
                  <br/>
                  As elaborated under the Privacy Policy, Bridge Fintech will keep all confidential information
                  confidential, including the Lender’s personal and business information, and shall not disclose it to
                  anyone except as required by law, and shall ensure that such confidential information is protected
                  with
                  security measures and a degree of care that it would apply to its own confidential information. Bridge
                  Fintech acknowledges that its employees, directors, agents and contractors shall use the confidential
                  information only for the intended purpose for which it is provided. Bridge Fintech shall use all
                  reasonable endeavours to ensure that its employees, directors, agents and contractors acknowledge and
                  comply with the provisions of these Terms of confidentiality as if such person was subject to these
                  Terms of confidentiality.
                </li>
                <br/>
                <br/>


                <li><b>LINKS TO THIRD-PARTIES' WEBSITES</b>
                  <br/>
                  The Website may contain links and interactive functionality interacting with the websites of third
                  parties. Bridge Fintech is not responsible for and has no liability for the functionality, actions,
                  inactions, privacy settings, privacy policies, terms, or content of any such website. Before enabling
                  any sharing functions to communicate with any such website or otherwise visiting any such website,
                  Bridge Fintech strongly recommends that the Lender reviews and understands the terms and conditions,
                  privacy policies, settings, and information-sharing functions of each such third-party website.
                </li>
                <br/>
                <br/>


                <li><b>INDEMNIFICATION</b>
                  <br/>
                  The Lender shall indemnify and hold harmless Bridge Fintech, its owner, licensee, affiliates,
                  subsidiaries, group companies (as applicable) and their respective officers, directors, agents, and
                  employees, from any claim or demand, or actions including reasonable attorneys' fees, made by any
                  third
                  party or penalty imposed due to or arising out of the Lender’s breach of these Terms, Privacy Policy
                  and
                  other policies, or the Lender’s violation of any law, rules or regulations or the rights (including
                  infringement of any intellectual property rights) of a third party.
                </li>
                <br/>
                <br/>


                <li><b>ONLY A PLATFORM</b>
                  <br/>
                  The Lender acknowledges and agrees that the Website is strictly a technology platform and
                  infrastructure
                  for connecting Borrowers and Lenders. Bridge Fintech shall not be liable for any reason whatsoever for
                  the Services and for any transactions consummated on the Website, and shall bear no liability for the
                  consequences to the Lender, of the Lender’s use of the Website. The Lender acknowledges and agrees
                  that
                  Bridge Fintech has carried out limited KYC checks on the Borrower, and that Bridge Fintech does not
                  guarantee the repayment of the loans being provided to the Borrower. The Lender shall be solely
                  responsible for any and all transactions facilitated on the Website through the Lender Account.
                </li>
                <br/>
                <br/>


                <li><b>TERMINATION</b>
                  <br/>
                  <ol style="list-style-type: none;">
                    <li>10.1. Bridge Fintech, in its sole discretion, may modify, suspend, or terminate access to, all
                      or
                      any portion of the Website at any time for any reason including termination for breach of any of
                      these Terms or the Privacy Policy.
                    </li>
                    <br/>
                    <li>10.2. The Lender shall be entitled to terminate the Lender’s access to the Website and the
                      Services thereof after all of the Committed Investment Amount, as indicated by it/him, has been
                      invested and all charges in relation to the Lender’s use of the Website have been fully paid.
                    </li>
                    <br/>
                    <li>10.3. None of the Lender’s content shall remain accessible on the Website upon termination. This
                      information cannot be recovered by the Lender, once the account is terminated.
                    </li>
                    <br/>
                    <li>10.4. The disclaimer of warranties, the limitation of liability, and the governing law
                      provisions
                      shall survive any termination of these Terms.
                    </li>
                  </ol>
                </li>
                <br/>
                <br/>


                <li><b>DISCLAIMER OF WARRANTIES</b>
                  <br/>
                  THE WEBSITE AND ALL INFORMATION, CONTENT, MATERIALS AND SERVICES INCLUDED. ON OR OTHERWISE MADE
                  AVAILABLE TO THE LENDER THROUGH THE WEBSITE (COLLECTIVELY, THE "CONTENTS") ARE PROVIDED BY BRIDGE
                  FINTECH ON AN "AS IS," "AS AVAILABLE" BASIS, WITHOUT REPRESENTATIONS OR WARRANTIES OF ANY KIND. BRIDGE
                  FINTECH MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF
                  THE WEBSITE, THE ACCURACY OR COMPLETENESS OF THE CONTENTS AND THE ACCURACY OF THE INFORMATION. BRIDGE
                  FINTECH SHALL HAVE NO RESPONSIBILITY FOR ANY DAMAGE TO THE LENDER’S COMPUTER SYSTEM OR LOSS OF DATA
                  THAT
                  RESULTS FROM THE DOWNLOAD OF ANY CONTENT, MATERIALS, DOCUMENT OR INFORMATION OR ANY OTHER LOSSES
                  INCURRED BY THE LENDER FOR BORROWER’S FAILURE TO REPAY LOANS. THE LENDER EXPRESSLY AGREES THAT THE USE
                  OF THE WEBSITE IS AT THE LENDER’S SOLE RISK. BRIDGE FINTECH WILL NOT BE LIABLE FOR ANY DAMAGES OF ANY
                  KIND ARISING FROM THE USE OF THE WEBSITE OR THE SERVICES OR THE CONTENTS INCLUDING, WITHOUT
                  LIMITATION,
                  DIRECT, INDIRECT, PUNITIVE, AND CONSEQUENTIAL DAMAGES, UNLESS OTHERWISE SPECIFIED IN WRITING. TO THE
                  FULL EXTENT PERMITTED BY LAW, BRIDGE FINTECH DISCLAIMS ANY AND ALL REPRESENTATIONS AND WARRANTIES WITH
                  RESPECT TO THE WEBSITE AND ITS CONTENTS, WHETHER EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION,
                  WARRANTIES OF TITLE, MERCHANTABILITY, AND FITNESS FOR A PARTICULAR PURPOSE OR USE.
                </li>
                <br/>
                <br/>


                <li><b>LIMITATION OF LIABILITY</b>
                  <br/>IN NO EVENT SHALL BRIDGE FINTECH, ITS DIRECTORS, EMPLOYEES OR AGENTS, BE LIABLE FOR ANY SPECIAL,
                  INCIDENTAL, INDIRECT OR CONSEQUENTIAL DAMAGES WHATSOEVER RESULTING FROM ANY (I) ERRORS, MISTAKES, OR
                  INACCURACIES OF CONTENT; (II) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING
                  FROM THE LENDER’S ACCESS TO AND USE OF THE WEBSITE; (III) ANY UNAUTHORIZED ACCESS TO OR USE OF THE
                  SECURE SERVERS AND/OR ANY AND ALL PERSONAL AND/OR BUSINESS AND/OR FINANCIAL INFORMATION STORED
                  THEREIN;
                  (IV) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE WEBSITE; (V) ANY BUGS, VIRUSES,
                  TROJAN
                  HORSES, OR THE LIKE, WHICH MAY BE TRANSMITTED TO OR THROUGH THE WEBSITE BY ANY THIRD PARTY; AND/OR
                  (VI)
                  ANY ERRORS OR OMISSIONS IN ANY CONTENT OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF
                  THE
                  USE OF ANY CONTENT POSTED, EMAILED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE WEBSITE, WHETHER
                  BASED ON WARRANTY, CONTRACT, TORT, OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT BRIDGE FINTECH IS
                  ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. SUBJECT TO THE ABOVE AND NOTWITHSTANDING ANYTHING TO THE
                  CONTRARY CONTAINED IN THESE TERMS, THE MAXIMUM AGGREGATE LIABILITY (WHETHER IN CONTRACT, TORT
                  (INCLUDING
                  NEGLIGENCE) OR EQUITY) OF BRIDGE FINTECH VIS-À-VIS ANY LENDER, REGARDLESS OF THE FORM OF CLAIM, SHALL
                  BE
                  LIMITED TO THE AGGREGATE OF FEES PAID BY THE LENDER TO BRIDGE FINTECH. THE FOREGOING LIMITATIONS OF
                  LIABILITY WILL APPLY NOTWITHSTANDING THE FAILURE OF ESSENTIAL PURPOSE OF ANY LIMITED REMEDY HEREIN.
                </li>
                <br/>
                <br/>


                <li><b>GOVERNING LAW AND DISPUTE RESOLUTION</b>
                  <br/>
                  These Terms shall be governed by and interpreted and construed in accordance with the laws of India.
                  The
                  courts of Bangalore, Karnataka shall have exclusive jurisdiction over any disputes arising under these
                  Terms.
                </li>
                <br/>
                <br/>

                <li><b>GRIEVANCE REDRESSAL MECHANISM</b>
                  <br/>
                  In accordance with the Information Technology Act, 2000 and Rules made thereunder, the name and
                  contact
                  details of the Grievance Officer are provided below:
                  <br/>
                  <p>
                    Name: John Stain Richard<br/>
                    Address: Bridge Fintech Solutions Private Limited,<br/>
                    118, 1st Floor, 80 Feet Road,<br/>
                    Koramangala 7th Block,<br/>
                    Bengaluru, Karnataka - 560095.<br/>
                    Cell: +91 98860 18625<br/>
                    E-mail: <a href="mailto:grievances@finzy.com">grievances@finzy.com</a>
                  </p>
                  <br/>
                  If the Lender wishes to make a complaint regarding any violation of the provisions of these Terms, the
                  Lender may send a written complaint to the Grievance Officer, who shall redress the complaint in
                  accordance with the provisions of the Information Technology Act, 2000 and Rules made thereunder.
                </li>
                <br/>
                <br/>


                <li><b>HOW TO CONTACT US</b>
                  <br/>
                  If the Lender has any questions or concerns about these Terms, Bridge Fintech may be contacted at
                  <a href="mailto:support@finzy.com">support@finzy.com</a>.
                </li>

                <br/>
                <br/>

                <li><b>MISCELLANEOUS</b>
                  <br/>
                  <ol style="list-style-type: none">
                    <li>16.1 It is hereby clarified that the Reserve Bank of India does not accept any responsibility
                      for
                      the correctness of any of the statements or representations made or opinions expressed by Bridge
                      Fintech, and does not provide any assurance for repayment of the loans lent on the Website.
                    </li>
                    <br/>
                    <li>16.2 It is further clarified that if Bridge Fintech ceases to carry on its activities, i.e.,
                      acting as an intermediary providing the Services via the Website or is wound up, all existing loan
                      agreements facilitated on the Website will continue to be managed and administered in accordance
                      with the ‘Business Continuity Plan’ available on the Website.
                    </li>
                    <br/>
                    <li>16.3 As required by the Reserve Bank of India under the P2P Regulations, Bridge Fintech has
                      appointed Catalyst Trusteeship Limited as Trustee who shall have the ability to operate the escrow
                      accounts for both lending and repayment of loans, and all existing loans shall therefore be
                      managed
                      and/or handled by the Trustee so appointed. The Lender hereby ratifies the appointment of such
                      Trustee.
                    </li>
                  </ol>
                </li>

                <br/>
                <br/>
                
                <li><b>finzyFLEX</b>
                  <br/>
                  <ol style="list-style-type: none;">
                    <li>17.1. Bridge Fintech (Finzy) will earn differential in interest between the interest rate paid 
                      by the borrower and Investor Interest Rate. Bridge Fintech (Finzy) will not earn such income,
                      if such interest differential is zero or is negative.
                    </li>
                    <br/>
                    <li>17.2. Bridge Fintech (Finzy) does not guarantee any rate of return or return of principal.
                      Investments made herein are subject to credit risk and performance of the underlying loans.
                    </li>
                    <br/>
                    <li>17.3. Investor Interest Rate referred herein is simple interest rate and is indicative.
                      Such interest amount will be paid either on periodic basis or upon  withdrawal
                    </li>
                    <br/>
                    <li>17.4. Periodic payouts and Withdrawal proceeds are offered on best effort basis. Such proceeds
                      will be paid by assignment of investor’s outstanding loans to another investor or from accumulated
                      return of an Investor. Under normal circumstances, you should expect funds in your bank
                      account within 7 days from the withdrawal request.
                    </li>
                    <br/>
                    <li>17.5. Allocation of new investments and reinvestment on repayments under finzyFLEX will happen
                      through auto investment mode. Investor might have an option to reverse any allocation into a loan
                      for a limited time period. Any reversal request will not be allowed post expiry of this time period.
                    </li>
                    <br/>
                    <li>17.6. Bridge Fintech (Finzy) may decide on timing of investment in loan and change the auto
                      allocation preferences (if any) from time to time.
                    </li>
                    <br/>
                    <li>17.7. Changes to SWIFT and nCash preferences and any Withdrawal request must be made only through
                      the investor dashboard on www.finzy.com. Setup or changes to nCash preferences may be effective
                      from the following cashflow period.
                    </li>
                    <br/>
                    <li>17.8. Interest calculation would be on actual/365 day count convention basis. If payout date
                      happens to be a banking holiday, payouts will be made on the next bank working day. For
                      working day and banking days, we shall follow RBI Holiday calendar for Mumbai.
                    </li>
                    <br/>
                    <li>17.9. Finzy reserves the right to withdraw any product offering or its variant or change the terms
                      of product offering without any notice.
                    </li>
                  </ol>
                </li>
              </ol>


            </div>
          </div>
        </mat-tab>

      </mat-tab-group>
    </div>

  </div>

</div>

<app-footer></app-footer>
